import ToolBar from "../../Components/ToolBar/ToolBar";
import { toast } from "react-toastify";
import { useContext, useState, useRef, useEffect } from "react";
import AppContext from "../../Context/AppContext";
import {
  RestSkuBatchInventoryListRequest,
  SKUBatchInventorySearchCriteria,
  PageListBean,
  BatchInventorySummaryDataPrintRequest,
  RestVendorPurchaseOnOrderListRequest,
  VendorPurchaseOnOrderSearchCriteria,
  CustomerATSInquiryCriteriaBean,
  AllFabricATSInquiryCriteriaBean,
  RestPageListBean,
  RestFabricStyleATSListRequest,
  PortalSalesOrderSearchCriteria,
  PortalSalesOrderBean,
  RestPortalSalesOrderRequest,
  RestReadRequest,
  CustomerSearchCriteria,
  RestCustomerListRequest,
  FabricStyleSearchCriteria,
  RestFabricStyleListBeanRequest,
  CustomerPaymentAgingHistoryCriteriaBean,
  AllFabricStyleCustomerATSInfoDetailsPrintRequest,
  RestCustomerSalesOnOrderListRequest,
  CustomerSalesOnOrderSearchCriteria
} from "../../Ds/ds";
// import { CustomerService } from "../../Services/CustomerService.js";
// import { FabricStyleService } from "../../Services/FabricStyleService.js";
import { RestReportBean } from "../../Ds/client_ds";
import {
  isEmpty,
  isEmptyArray,
  isEmptyString,
  toCommaSeperatedAmount,
  ColumnDefinition,
} from "../../Utils/util";
import PageBar from "../../Components/ToolBar/PageBar";
import Loader from "../../Components/Loder";
import InputTextBox from "../../Components/Base/InputTextBox";
import CustomButton from "../../Components/Base/CustomButton";
import Modal from "../../Components/Modal";
import service from "../../Services/Service";
import {
  TOAST_ERROR,
  TOAST_SUCESS,
  TOAST_WARN,
} from "../../Utils/appConstants";
import ReactTable from "../../Components/Table";
import Image from "../../Components/Base/Image";
import InValidAccess from "../../Components/InValidAccess";
import { SecurityAccessManager } from "../../Security/SecurityAccessManager";
import NoData from "../../Components/NoData";
// import CustomTable from "../../Components/Base/CustomTable";
import ViewToggle from "../../Components/ViewToggle";
import DatePicker from "../../Components/Base/DatePicker";
import { focusNext } from "../../Utils/focusUtils";
// import "./SalesPersonOrder.css";

// InputTextbox (lowercase b) is the same component — used by the lookup JSX below
const InputTextbox = InputTextBox;

const SPO_INLINE_STYLES = `
  .spo-lv-order-link {
    color: #2563eb;
    font-weight: 600;
    text-decoration: underline;
    cursor: pointer;
  }
  .spo-lv-order-link:hover {
    color: #1d4ed8;
    text-decoration: none;
  }

  /* ── Responsive Card Grid (Header Node) ── */
  .spo-responsive-grid-wrap { width: 100%; }
  .spo-responsive-grid-header {
    font-size: 13px; color: #6b7280;
    margin-bottom: 12px; padding: 0 2px;
  }
  .spo-responsive-grid {
    display: grid; gap: 16px;
    grid-template-columns: 1fr;
  }
  @media (min-width: 560px)  { .spo-responsive-grid { grid-template-columns: repeat(2, 1fr); } }
  @media (min-width: 900px)  { .spo-responsive-grid { grid-template-columns: repeat(3, 1fr); } }
  @media (min-width: 1200px) { .spo-responsive-grid { grid-template-columns: repeat(auto-fill, minmax(280px, 1fr)); } }

  /* ── List-view card grid ── */
  .spo-lv-card-grid {
    display: grid; gap: 14px;
    grid-template-columns: 1fr;
    padding: 4px 0;
  }
  @media (min-width: 560px)  { .spo-lv-card-grid { grid-template-columns: repeat(2, 1fr); } }
  @media (min-width: 900px)  { .spo-lv-card-grid { grid-template-columns: repeat(3, 1fr); } }
  @media (min-width: 1200px) { .spo-lv-card-grid { grid-template-columns: repeat(auto-fill, minmax(280px, 1fr)); } }

  .spo-lv-card {
    background: #fff;
    border: 1px solid #e5e7eb;
    border-radius: 12px;
    box-shadow: 0 2px 8px rgba(0,0,0,0.06);
    overflow: hidden;
    display: flex; flex-direction: column;
    transition: box-shadow .2s;
  }
  .spo-lv-card:hover { box-shadow: 0 4px 16px rgba(0,0,0,0.1); }

  .spo-lv-card__header {
    display: flex; align-items: center; justify-content: space-between;
    padding: 12px 14px 8px;
    background: #f0f7ff;
    border-bottom: 1px solid #dbeafe;
  }
  .spo-lv-card__order-num { font-size: 15px; font-weight: 700; }
  .spo-lv-card__line-badge {
    font-size: 11px; background: #2563eb; color: #fff;
    border-radius: 20px; padding: 2px 8px; font-weight: 600;
  }

  .spo-lv-card__body { padding: 10px 14px; flex: 1; }
  .spo-lv-card__row {
    display: flex; justify-content: space-between; align-items: center;
    padding: 5px 0;
    border-bottom: 1px solid #f3f4f6;
    font-size: 12.5px;
  }
  .spo-lv-card__row:last-child { border-bottom: none; }
  .spo-lv-card__label { color: #6b7280; }
  .spo-lv-card__value { color: #111827; font-weight: 600; text-align: right; }

  .spo-lv-card__footer {
    padding: 10px 14px;
    border-top: 1px solid #f3f4f6;
    display: flex; justify-content: flex-end;
  }

  /* ── Single Confirm Order button in Sales Order Node ── */
  .spo-son-confirm-row {
    padding: 14px 16px 4px;
    display: flex; justify-content: flex-end;
  }
  .spo-confirm-order-btn--full {
    width: 100%;
    padding: 11px 20px;
    font-size: 14px;
    font-weight: 700;
    background: linear-gradient(135deg, #16a34a, #15803d);
    color: #fff;
    border: none; border-radius: 8px; cursor: pointer;
    transition: opacity .15s, transform .1s;
  }
  .spo-confirm-order-btn--full:hover:not(:disabled) { opacity: .92; transform: translateY(-1px); }
  .spo-confirm-order-btn--full:disabled { opacity: .55; cursor: not-allowed; }

  /* ── Empty hint when no atsInfos yet ── */
  .spo-node-empty-hint {
    text-align: center; padding: 40px 20px;
    color: #6b7280; font-size: 14px;
    background: #f9fafb; border-radius: 10px;
    border: 1.5px dashed #d1d5db; margin: 8px 0;
  }

  /* ── Editable Price input inside a card row ── */
  .spo-card-row__input {
    width: 100px;
    text-align: right;
    font-weight: 600;
    font-size: 12.5px;
    padding: 3px 6px;
    border: 1px solid #d1d5db;
    border-radius: 6px;
    outline: none;
    background: #f9fafb;
  }
  .spo-card-row__input:focus {
    border-color: #16a34a;
    background: #fff;
    box-shadow: 0 0 0 2px rgba(22,163,74,0.15);
  }
  .spo-card-row__input:disabled {
    background: #f3f4f6;
    color: #9ca3af;
    cursor: not-allowed;
  }

  /* ── Pagination + view toggle wrapper inside Header Node ── */
  .spo-header-node-controls {
    display: flex; align-items: center; justify-content: space-between;
    flex-wrap: wrap; gap: 8px;
    padding: 6px 2px 10px;
    border-bottom: 1px solid #e5e7eb;
    margin-bottom: 12px;
  }
`;

// ─── Inline lookup modal styles ──────────────────────────────────────────────
const LOOKUP_MODAL_STYLES = `
  /* ── Backdrop ── */
  .spo-lookup-backdrop {
    position: fixed; inset: 0;
    background: rgba(0,0,0,0.45);
    z-index: 1200;
    display: flex; align-items: flex-start; justify-content: center;
    padding-top: 80px;
  }

  /* ── Modal panel ── */
  .spo-lookup-panel {
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 20px 60px rgba(0,0,0,0.25);
    width: min(640px, 95vw);
    max-height: 75vh;
    display: flex; flex-direction: column;
    overflow: hidden;
    animation: spoLookupIn .18s ease;
  }
  @keyframes spoLookupIn {
    from { opacity:0; transform:translateY(-12px); }
    to   { opacity:1; transform:translateY(0); }
  }

  /* ── Header bar ── */
  .spo-lookup-header {
    display: flex; align-items: center; justify-content: space-between;
    padding: 14px 18px 12px;
    border-bottom: 1px solid #e5e7eb;
    background: #f8fafc;
    flex-shrink: 0;
  }
  .spo-lookup-title {
    font-size: 15px; font-weight: 700; color: #111827;
    display: flex; align-items: center; gap: 7px;
  }
  .spo-lookup-title-icon { font-size: 18px; }
  .spo-lookup-close-btn {
    background: none; border: none; cursor: pointer;
    font-size: 20px; color: #6b7280; line-height: 1;
    padding: 2px 6px; border-radius: 6px;
    transition: background .15s, color .15s;
  }
  .spo-lookup-close-btn:hover { background: #fee2e2; color: #dc2626; }

  /* ── Search bar ── */
  .spo-lookup-search-wrap {
    padding: 12px 16px 10px;
    border-bottom: 1px solid #f0f0f0;
    flex-shrink: 0;
    background: #fff;
  }
  .spo-lookup-search-inner {
    display: flex; align-items: center; gap: 8px;
    background: #f3f4f6; border-radius: 8px;
    padding: 7px 12px;
    border: 1.5px solid transparent;
    transition: border-color .2s;
  }
  .spo-lookup-search-inner:focus-within { border-color: #2563eb; background: #fff; }
  .spo-lookup-search-icon { color: #9ca3af; font-size: 15px; flex-shrink:0; }
  .spo-lookup-search-input {
    border: none; background: transparent; outline: none;
    font-size: 14px; color: #111827; flex: 1; min-width: 0;
  }
  .spo-lookup-search-hint {
    font-size: 11px; color: #9ca3af; flex-shrink: 0;
  }
  .spo-lookup-search-clear {
    background: none; border: none; cursor: pointer;
    color: #9ca3af; font-size: 16px; line-height: 1; padding: 0 2px;
    flex-shrink: 0;
  }
  .spo-lookup-search-clear:hover { color: #dc2626; }

  /* ── Status bar ── */
  .spo-lookup-status {
    padding: 5px 16px 3px;
    font-size: 11.5px; color: #6b7280;
    flex-shrink: 0;
  }
  .spo-lookup-status-count { font-weight: 600; color: #374151; }
  .spo-lookup-status-loading { color: #2563eb; font-style: italic; }

  /* ── Results list ── */
  .spo-lookup-list {
    overflow-y: auto; flex: 1; padding: 6px 0;
  }
  .spo-lookup-item {
    display: flex; align-items: center; gap: 12px;
    padding: 10px 18px;
    cursor: pointer;
    transition: background .12s;
    border-bottom: 1px solid #f9fafb;
  }
  .spo-lookup-item:hover { background: #eff6ff; }
  .spo-lookup-item:last-child { border-bottom: none; }
  .spo-lookup-item--selected { background: #dbeafe; }
  .spo-lookup-item__code {
    font-weight: 700; font-size: 13.5px; color: #1d4ed8;
    min-width: 120px; font-family: monospace;
    background: #eff6ff; border-radius: 5px; padding: 3px 8px;
    flex-shrink: 0;
  }
  .spo-lookup-item__desc {
    font-size: 13px; color: #374151; overflow: hidden;
    text-overflow: ellipsis; white-space: nowrap;
  }
  .spo-lookup-item__chevron {
    margin-left: auto; color: #93c5fd; font-size: 17px; flex-shrink: 0;
  }

  /* ── Empty / no-results state ── */
  .spo-lookup-empty {
    text-align: center; padding: 36px 20px; color: #9ca3af;
  }
  .spo-lookup-empty__icon { font-size: 32px; margin-bottom: 8px; }
  .spo-lookup-empty__text { font-size: 14px; font-weight: 600; color: #6b7280; }
  .spo-lookup-empty__hint { font-size: 12px; margin-top: 4px; }

  /* ── Lookup trigger button (🔍 icon next to the input) ── */
  .spo-lookup-trigger-btn {
    background: none; border: none; cursor: pointer;
    padding: 0 4px; color: #6b7280; font-size: 16px;
    line-height: 1; transition: color .15s;
  }
  .spo-lookup-trigger-btn:hover { color: #2563eb; }

  /* ── Field wrapper so the 🔍 button sits inline ── */
  .spo-lookup-field-wrap {
    display: flex; align-items: center; gap: 4px; position: relative;
  }
  .spo-lookup-field-wrap > *:first-child { flex: 1; min-width: 0; }
`;

// ─── CustomerLookupModal ──────────────────────────────────────────────────────
// Self-contained modal that calls service("getCustomerPageList") directly.
// Props:
//   isOpen          – boolean
//   onClose         – () => void
//   onSelect        – (item: { code, description }) => void
//   token           – auth token passed from parent
//   serviceCall     – the `service` function from parent closure
const CustomerLookupModal = ({ isOpen, onClose, onSelect, token, serviceCall }) => {
  const [query, setQuery]   = useState("");
  const [list, setList]     = useState([]);
  const [loading, setLoading] = useState(false);
  const inputRef            = useRef(null);
  const debounceRef         = useRef(null);

  // Auto-focus search input when modal opens; clear stale results
  useEffect(() => {
    if (isOpen) {
      setQuery(""); setList([]);
      setTimeout(() => inputRef.current && inputRef.current.focus(), 80);
    }
  }, [isOpen]);

  const doSearch = (q) => {
    if (!q.trim()) { setList([]); return; }
    setLoading(true);
    const searchCriteria = new CustomerSearchCriteria();
    searchCriteria.companyCode          = process.env.REACT_APP_COMPANY;
    searchCriteria.customerCodeStartsWith = q.toUpperCase();
    searchCriteria.customerNameContains   = q;
    const req = new RestCustomerListRequest();
    req.pageInput            = new PageListBean();
    req.pageInput.pageSize   = 100;
    req.searchCriteria       = searchCriteria;
    serviceCall(
      token,
      "getCustomerPageList",
      req,
      (response) => {
        const customers = response?.data?.customerPageList?.customers || [];
        setList(customers.map((c) => ({ code: c.code, description: c.description })));
        setLoading(false);
      },
      () => { setList([]); setLoading(false); },
    );
  };

  const handleChange = (e) => {
    const val = e.target.value;
    setQuery(val);
    clearTimeout(debounceRef.current);
    debounceRef.current = setTimeout(() => doSearch(val), 280);
  };

  const handleKeyDown = (e) => {
    if (e.key === "Escape") onClose();
    if (e.key === "Enter" && query.trim()) doSearch(query);
  };

  const handleSelect = (item) => { onSelect(item); onClose(); };

  if (!isOpen) return null;
  return (
    <div className="spo-lookup-backdrop" onClick={onClose}>
      <div className="spo-lookup-panel" onClick={(e) => e.stopPropagation()}>
        {/* Header */}
        <div className="spo-lookup-header">
          <div className="spo-lookup-title">
            <span className="spo-lookup-title-icon">👤</span>
            Customer Lookup
          </div>
          <button className="spo-lookup-close-btn" onClick={onClose} title="Close">✕</button>
        </div>
        {/* Search */}
        <div className="spo-lookup-search-wrap">
          <div className="spo-lookup-search-inner">
            <span className="spo-lookup-search-icon">🔍</span>
            <input
              ref={inputRef}
              className="spo-lookup-search-input"
              placeholder="Search by customer code or name…"
              value={query}
              onChange={handleChange}
              onKeyDown={handleKeyDown}
            />
            {query && (
              <button
                className="spo-lookup-search-clear"
                onClick={() => { setQuery(""); setList([]); inputRef.current && inputRef.current.focus(); }}
              >×</button>
            )}
            <span className="spo-lookup-search-hint">Enter / type to search</span>
          </div>
        </div>
        {/* Status */}
        <div className="spo-lookup-status">
          {loading
            ? <span className="spo-lookup-status-loading">⏳ Searching…</span>
            : list.length > 0
              ? <><span className="spo-lookup-status-count">{list.length}</span> result{list.length !== 1 ? "s" : ""} found</>
              : query ? "No results" : "Type to search customers"}
        </div>
        {/* Results */}
        <div className="spo-lookup-list">
          {!loading && list.length === 0 && query && (
            <div className="spo-lookup-empty">
              <div className="spo-lookup-empty__icon">🔎</div>
              <div className="spo-lookup-empty__text">No customers found</div>
              <div className="spo-lookup-empty__hint">Try a different code or name</div>
            </div>
          )}
          {list.map((item) => (
            <div key={item.code} className="spo-lookup-item" onClick={() => handleSelect(item)}>
              <span className="spo-lookup-item__code">{item.code}</span>
              <span className="spo-lookup-item__desc">{item.description}</span>
              <span className="spo-lookup-item__chevron">›</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

// ─── FabricStyleLookupModal ───────────────────────────────────────────────────
// Self-contained modal that calls service("getActiveFabricStylesForAutoComplete").
// Props: same shape as CustomerLookupModal
const FabricStyleLookupModal = ({ isOpen, onClose, onSelect, token, serviceCall }) => {
  const [query, setQuery]     = useState("");
  const [list, setList]       = useState([]);
  const [loading, setLoading] = useState(false);
  const inputRef              = useRef(null);
  const debounceRef           = useRef(null);

  useEffect(() => {
    if (isOpen) {
      setQuery(""); setList([]);
      setTimeout(() => inputRef.current && inputRef.current.focus(), 80);
    }
  }, [isOpen]);

  const doSearch = (q) => {
    if (!q.trim()) { setList([]); return; }
    setLoading(true);
    const searchCriteria = new FabricStyleSearchCriteria();
    searchCriteria.companyCode              = process.env.REACT_APP_COMPANY;
    searchCriteria.fabricStyleCodeStartsWith = q.toUpperCase();
    searchCriteria.fabricStyleNameStartsWith = q;
    const pageInput      = new PageListBean();
    pageInput.pageSize   = 100;
    const input          = new RestFabricStyleListBeanRequest();
    input.companyCode    = process.env.REACT_APP_COMPANY;
    input.pageInput      = pageInput;
    input.code           = q;
    input.searchCriteria = searchCriteria;
    serviceCall(
      token,
      "getActiveFabricStylesForAutoComplete",
      input,
      (response) => {
        const styles = response?.data?.fabricStylePageList?.fabricStyles || [];
        setList(
          styles
            .filter((s) => s.isActive)
            .map((s) => ({ code: s.fabricStyleCode, description: s.fabricStyleName })),
        );
        setLoading(false);
      },
      () => { setList([]); setLoading(false); },
    );
  };

  const handleChange = (e) => {
    const val = e.target.value;
    setQuery(val);
    clearTimeout(debounceRef.current);
    debounceRef.current = setTimeout(() => doSearch(val), 280);
  };

  const handleKeyDown = (e) => {
    if (e.key === "Escape") onClose();
    if (e.key === "Enter" && query.trim()) doSearch(query);
  };

  const handleSelect = (item) => { onSelect(item); onClose(); };

  if (!isOpen) return null;
  return (
    <div className="spo-lookup-backdrop" onClick={onClose}>
      <div className="spo-lookup-panel" onClick={(e) => e.stopPropagation()}>
        {/* Header */}
        <div className="spo-lookup-header">
          <div className="spo-lookup-title">
            <span className="spo-lookup-title-icon">🧵</span>
            Item / Fabric Style Lookup
          </div>
          <button className="spo-lookup-close-btn" onClick={onClose} title="Close">✕</button>
        </div>
        {/* Search */}
        <div className="spo-lookup-search-wrap">
          <div className="spo-lookup-search-inner">
            <span className="spo-lookup-search-icon">🔍</span>
            <input
              ref={inputRef}
              className="spo-lookup-search-input"
              placeholder="Search by fabric code or name…"
              value={query}
              onChange={handleChange}
              onKeyDown={handleKeyDown}
            />
            {query && (
              <button
                className="spo-lookup-search-clear"
                onClick={() => { setQuery(""); setList([]); inputRef.current && inputRef.current.focus(); }}
              >×</button>
            )}
            <span className="spo-lookup-search-hint">Enter / type to search</span>
          </div>
        </div>
        {/* Status */}
        <div className="spo-lookup-status">
          {loading
            ? <span className="spo-lookup-status-loading">⏳ Searching…</span>
            : list.length > 0
              ? <><span className="spo-lookup-status-count">{list.length}</span> active style{list.length !== 1 ? "s" : ""} found</>
              : query ? "No results" : "Type to search fabric styles"}
        </div>
        {/* Results */}
        <div className="spo-lookup-list">
          {!loading && list.length === 0 && query && (
            <div className="spo-lookup-empty">
              <div className="spo-lookup-empty__icon">🔎</div>
              <div className="spo-lookup-empty__text">No fabric styles found</div>
              <div className="spo-lookup-empty__hint">Try a different code or name</div>
            </div>
          )}
          {list.map((item) => (
            <div key={item.code} className="spo-lookup-item" onClick={() => handleSelect(item)}>
              <span className="spo-lookup-item__code">{item.code}</span>
              <span className="spo-lookup-item__desc">{item.description}</span>
              <span className="spo-lookup-item__chevron">›</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};


// ─── OnHandQty modal detail table ────────────────────────────────────────────
const OnHandQtyDetails = ({ invLines }) => {
  
  
  const tableColumns = [
   
    { header: "ROLLSKU", accessor: "rollSkuNumber",  sortable: true ,alignment: "center"},
     { header: "SKU", accessor: "skuNumber",  sortable: true,alignment: "center" },
    { header: "OnHandQty",  accessor: "onHandQuantity", sortable: true, alignment: "center" },
  ];
  return (
    <div className="model-fw">
      <ReactTable data={invLines} columns={tableColumns} />
    </div>
  );
};

// ─── VendorOnOrder modal detail table ────────────────────────────────────────
const VendorOnOrderDetails = ({ onOrderLines }) => {

  
  const tableColumns = [
     { header: "vendor#", accessor: "vendorCode", sortable: true ,alignment: "center"},
      { header: "PO#", accessor: "purchaseOrderNumber", sortable: true ,alignment: "center"},
    // { header: "PO#", accessor: "purchaseOrderNumber", sortable: true ,alignment: "center"},
    { header: "OnOrder",  accessor: "onOrderQuantity",     sortable: true, alignment: "center" },
    // { header: "ETA", accessor: "etaDate",             sortable: true ,alignment: "center"},
  ];
  return (
    <div className="model-fw">
      <ReactTable data={onOrderLines} columns={tableColumns} />
    </div>
  );
};

// ─── CustomerOnOrder modal detail table ──────────────────────────────────────
const CustomerOnOrderDetails = ({ customerOnOrderLines }) => {

  
  const tableColumns = [
    { header: "customer#", accessor: "customerCode",     sortable: true ,alignment: "center"},
    { header: "customerName",    accessor: "customerName",         sortable: true, alignment: "center"},
    { header: "OrderQty",     accessor: "onOrderQuantity", sortable: true, alignment: "center" },
    
  ];
  return (
    <div className="model-fw">
      <ReactTable data={customerOnOrderLines} columns={tableColumns} />
    </div>
  );
};

// ─── Order Qty manual input popup ────────────────────────────────────────────
const OrderQtyPopup = ({ isOpen, item, onClose, onSave }) => {
  const [inputValue, setInputValue] = useState("");
  const inputRef = useRef(null);

  useEffect(() => {
    if (isOpen) {
      setInputValue(item?.orderQuantity != null ? String(item.orderQuantity) : "");
      setTimeout(() => inputRef.current && inputRef.current.focus(), 100);
    }
  }, [isOpen, item]);

  if (!isOpen || !item) return null;

  const handleSave = () => {
    const qty = parseFloat(inputValue);
    if (isNaN(qty) || qty < 0) {
      alert("Please enter a valid quantity.");
      return;
    }
    onSave(item, qty);
    onClose();
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") handleSave();
    if (e.key === "Escape") onClose();
  };

  return (
    <div className="spo-popup-overlay" onClick={onClose}>
      <div className="spo-popup-card" onClick={(e) => e.stopPropagation()}>
        <div className="spo-popup-label">Enter Order Quantity</div>
        <div className="spo-popup-title">
          {item.fabricStyleCode}
          <span className="spo-popup-title-sub">{item.fabricStyleColorCode}</span>
        </div>
        <div className="spo-popup-input-group">
          <label className="spo-popup-input-label">Order Qty (yards)</label>
          <input
            ref={inputRef}
            type="number"
            min="0"
            step="1"
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
            onKeyDown={handleKeyDown}
            placeholder="e.g. 500"
            className="spo-popup-input"
          />
          <div style={{ fontWeight: 700, fontSize: "12px", marginTop: "6px", color: "#374151" }}>
            Tab to add text
          </div>
        </div>
        {item.orderQuantity != null && (
          <div className="spo-popup-hint">
            Current value: <strong>{toCommaSeperatedAmount(item.orderQuantity)}</strong>
          </div>
        )}
        <div className="spo-popup-btn-row">
          <button onClick={onClose} className="spo-popup-btn-cancel">Cancel</button>
          <button onClick={handleSave} className="spo-popup-btn-save">Save</button>
        </div>
      </div>
    </div>
  );
};

// ─── Single data row inside a card ───────────────────────────────────────────
// `editable` swaps the static value span for an inline number input.
// `rawValue` is the unformatted numeric value used to seed the input
// (formatted display values like "1,234.00" aren't valid number-input values).
// `onValueChange(newValue)` fires on blur / Enter with the raw string typed.
const CardRow = ({
  icon,
  label,
  value,
  clickable,
  onClick,
  valueColor,
  last,
  editable,
  rawValue,
  onValueChange,
  disable,
}) => (
  <div className={`spo-card-row${last ? " spo-card-row--last" : ""}`}>
    <div className="spo-card-row__left">
      <span className="spo-card-row__icon">{icon}</span>
      <span className="spo-card-row__label">{label}</span>
    </div>
    {editable ? (
      <input
        type="number"
        step="0.01"
        min="0"
        className="spo-card-row__input"
        style={{ color: valueColor }}
        defaultValue={rawValue != null ? rawValue : 0}
        disabled={disable}
        onBlur={(e) => onValueChange && onValueChange(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            e.preventDefault();
            e.target.blur();
          }
        }}
      />
    ) : (
      <span
        onClick={clickable ? onClick : undefined}
        className={`spo-card-row__value${clickable ? " spo-card-row__value--clickable" : ""}`}
        style={{ color: clickable ? valueColor : "#111827" }}
      >
        {value}
        {clickable && <span className="spo-card-row__chevron">›</span>}
      </span>
    )}
  </div>
);

// ─── Sales Order Node ─────────────────────────────────────────────────────────
// Displays all lines that have been successfully saved via "+ Add Sales".
const SalesOrderNode = ({ salesOrderLines, salesOrderNumber, onConfirmOrder, confirmingOrderKey, disable, onPriceChange }) => {

  
  if (isEmptyArray(salesOrderLines)) {
    return (
      <div className="spo-sales-order-node spo-sales-order-node--empty">
        <div className="spo-son-empty-icon">🛒</div>
        <div className="spo-son-empty-text">No lines added yet</div>
        <div className="spo-son-empty-sub">Click "+ Add Sales" on any style card above</div>
      </div>
    );
  }

  const totalQty = salesOrderLines.reduce((sum, l) => sum + (l.orderQuantity || 0), 0);
  // ONE confirm key per order number — all lines share the same salesOrderNumber
  const orderConfirmKey = salesOrderNumber || "current-order";
 
  
  const isConfirming    = confirmingOrderKey === orderConfirmKey;

  return (
    <div className="spo-sales-order-node">
      {/* ── Node Header ── */}
      <div className="spo-son-header">
        <div className="spo-son-header__left">
          <span className="spo-son-title">Sales Order Lines</span>
          <span className="spo-son-badge">{salesOrderLines.length} line{salesOrderLines.length !== 1 ? "s" : ""}</span>
        </div>
        {salesOrderNumber && (
          <div className="spo-son-order-num">Order # {salesOrderNumber}</div>
        )}
      </div>

      {/* ── Line Cards ── */}
      <div className="spo-son-lines">
        {salesOrderLines.map((ln, idx) => {
          
          
          const isWhite = (ln.fabricStyleColorCode || "").toUpperCase().includes("WHITE");
          return (
            <div key={idx} className="spo-son-line-card">
              {/* Top: image + info */}
              <div className="spo-son-line-card__top">
                <div className="spo-son-line-card__img-wrap">
                  {/* <Image
                    url={`${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_IMAGE_PATH}${ln.fabricStyleColorImagePath}`}
                    altName={`${ln.fabricStyleCode} - image`}
                  /> */}
                 <Image
  url={`${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_IMAGE_PATH}${
    ln.fabricStyleImagePath || ln.fabricStyleColorImagePath
  }`}
  altName={`${ln.fabricStyleCode} - image`}
/>
                </div>
                <div className="spo-son-line-card__info">
                  <div className="spo-son-line-code">{ln.fabricStyleCode}</div>
                  <div className="spo-son-line-name">{ln.fabricStyleName}</div>
                  {/* Color Badge */}
                  <div className="spo-color-badge" style={{ marginTop: "6px" }}>
                    <span
                      // className={`spo-color-badge__dot${isWhite ? " spo-color-badge__dot--white-border" : ""}`}
                      style={{ background:(ln.fabricStyleColorCode) }}
                    />
                    <span className="spo-color-badge__text">{ln.fabricStyleColorCode}</span>
                    
                  </div>
                </div>
              </div>

              {/* Divider */}
              <div className="spo-card-divider" />

              {/* Data rows */}
              <div>
                <CardRow icon="📦" label="On Hand Qty"       value={toCommaSeperatedAmount(ln.onHandQuantity)}          valueColor="#16a34a" />
                {/* valueColor="#2563eb" /> */}
                {/* <CardRow icon="🚚" label="Vendor On Order"   value={toCommaSeperatedAmount(ln.vendorOnOrderQuantity)}   valueColor="#2563eb" />
                <CardRow icon="🏪" label="Customer On Order" value={toCommaSeperatedAmount(ln.customerOnOrderQuantity)}  valueColor="#2563eb"/>
                <CardRow
                  icon="🛒"
                  label="Order Qty"
                  value={ln.orderQuantity != null ? toCommaSeperatedAmount(ln.orderQuantity) : <span className="spo-order-qty-placeholder">—</span>}
                  valueColor="#ea580c"
                  last
                /> */}
                <CardRow
                  icon="💰"
                  label="Price"
                  value={toCommaSeperatedAmount(ln.price)}
                  rawValue={ln.price || 0}
                  editable={!disable}
                  disable={disable}
                  onValueChange={(newValue) => onPriceChange && onPriceChange(idx, newValue)}
                  valueColor="#16a34a"
                />
                 <CardRow icon="💵" label="Total Amount"       value={toCommaSeperatedAmount(ln.onHandQuantity) * toCommaSeperatedAmount(ln.price)}          valueColor="#16a34a" />
              </div>
              

              {/* Saved indicator only — NO per-line confirm button */}
              <div className="spo-son-line-footer">
                <div className="spo-son-line-saved-badge">✓ Saved to Order</div>
              </div>
            </div>
          );
        })}
      </div>

      {/* ── Summary Footer ── */}
      <div className="spo-son-footer">
        <div className="spo-son-footer__label">Total Order Qty</div>
        <div className="spo-son-footer__value">{toCommaSeperatedAmount(totalQty)} YD</div>
      </div>

      {/* ── ONE Confirm Order button for the entire order ── */}
      <div className="spo-son-confirm-row">
        <button
          className="spo-confirm-order-btn spo-confirm-order-btn--full"
          onClick={() => onConfirmOrder(orderConfirmKey)}
          disabled={disable}
        >
          {isConfirming ? "⏳ Confirming…" : "✔ Confirm Order"}
        </button>
      </div>
    </div>
  );
};

// ─── MAIN COMPONENT ───────────────────────────────────────────────────────────
export default function SalesPersonOrder() {
  const { token, setisSessionExpeired, session } = useContext(AppContext);
  const [atsInfos, setAtsInfos]               = useState([]);
  const [criteria, setCriteria]               = useState(new AllFabricATSInquiryCriteriaBean());


  
  
  // criteriaRef mirrors criteria so loadPage can always read the LATEST value
  // even when called immediately after setCriteria() (before the next render).
  const criteriaRef                           = useRef(new AllFabricATSInquiryCriteriaBean());
  const title                                 = "Sales Person Order Details";

  // ── Pagination state ───────────────────────────────────────────────────────
  // ALL three values use the ref pattern so loadPage / loadNext / loadPrevious
  // always read the LATEST value and never a stale closure.

  const [totalCount, setTotalCount] = useState(0);

  // pageSize — starts at 20, updated from server response
  // pageSizeRef lets loadPage() always send the correct value to the server
  // even before React has committed the state update.
  const [pageSize,   setPageSizeState] = useState(20);
  const pageSizeRef                    = useRef(20);
  const setPageSize = (val) => { pageSizeRef.current = val; setPageSizeState(val); };

  // page / maxPage — same ref pattern for navigation buttons
  const [page,    setPageState]    = useState(1);
  const [maxPage, setMaxPageState] = useState(1);
  const pageRef                    = useRef(1);
  const maxPageRef                 = useRef(1);
  const setPage    = (val) => { pageRef.current    = val; setPageState(val);    };
  const setMaxPage = (val) => { maxPageRef.current = val; setMaxPageState(val); };
  const [isLoading, setIsLoading]             = useState(false);
  const [isShowPdf, setIsShowPdf]             = useState(false);
  const [isShowExcel, setIsShowExcel]         = useState(false);
  const [disable, setDisable]                 = useState(false);
  const inputRef                              = useRef(null);
  const buttonRef                             = useRef(null);
  // const disable
  // ── Sequential Enter-key focus navigation refs ────────────────────────────
  // Order: customerCode → customerPurchaseOrderNumber → orderDate →
  //        orderStartDate → orderStopDate → fabricStyleCode →
  //        fabricStyleColorCode → fetchButton
  const poNumberRef                           = useRef(null);
  const orderDateRef                          = useRef(null);
  const orderStartDateRef                     = useRef(null);
  const orderStopDateRef                      = useRef(null);
  const colorCodeRef                          = useRef(null);
  const fetchButtonRef                        = useRef(null);

  // Helper: focus the native input inside a component ref (handles both plain
  // <input> elements and wrapper objects that expose a .focus() method).
  const focusRef = (ref) => {
    if (!ref || !ref.current) return;
    const el = ref.current;
    if (typeof el.focus === "function") { el.focus(); return; }
    // Some InputTextBox wrappers expose the underlying <input> via .inputRef
    if (el.inputRef && typeof el.inputRef.focus === "function") { el.inputRef.focus(); return; }
    // Last resort: query the first focusable input inside the element
    const inner = el.querySelector && el.querySelector("input, select, textarea, [tabindex]");
    if (inner) inner.focus();
  };

  // ── Sales Order Node state ─────────────────────────────────────────────────
  // Accumulates every line successfully saved via "+ Add Sales".
  // salesOrderNumber mirrors the customerOrder key returned by the server.
  const [salesOrderLines, setSalesOrderLines]     = useState([]);
  const [salesOrderNumber, setSalesOrderNumber]   = useState(null);

  // ── Price edit handler ─────────────────────────────────────────────────────
  // Called from the editable Price row in the Sales Order Node. Updates the
  // matching line inside salesOrderLines so the modified price is reflected
  // both on screen and in the next request sent to the backend.
  const updateLinePrice = (idx, newPriceValue) => {
    const parsed = parseFloat(newPriceValue);
    const safePrice = isNaN(parsed) || parsed < 0 ? 0 : parsed;
    setSalesOrderLines((prev) =>
      prev.map((line, i) => (i === idx ? { ...line, price: safePrice } : line))
    );
  };

  // ── Active node tab — "header" (default) | "salesOrder" ───────────────────
  const [activeNode, setActiveNode] = useState("header");

  // ── List-view state (readPortalSalesOrder results) ─────────────────────────
  const [portalSalesOrders, setPortalSalesOrders] = useState([]);
  const [isListView, setIsListView]               = useState(false);

  // ── customerOrder session ref ──────────────────────────────────────────────
  // Stores the customerOrder key returned by the server after the FIRST
  // addSalesLine call for a given header. All subsequent clicks with the SAME
  // header reuse this key so lines go into the existing order, not a new one.
  // Cleared automatically whenever any header field changes.
  const currentCustomerOrderRef = useRef(null);
  const lastHeaderKeyRef        = useRef(null);

  // Keeps a snapshot of the line being saved so handleSalesResponse can push
  // it into salesOrderLines on success without prop-drilling.
  const pendingSalesLineRef = useRef(null);

  // Builds a stable string fingerprint from the 5 header fields.
  // Any change in these fields produces a different key → new customerOrder.
  const buildHeaderKey = (rc, customerCode) =>
    [
      customerCode                   || "",
      rc.customerPurchaseOrderNumber || "",
      rc.orderDate                   || "",
      rc.orderStartDate              || "",
      rc.orderStopDate               || "",
    ].join("|");

  const [isOnHandModelOpen, setIsOnHandModelOpen]           = useState(false);
  const [isOnVenOdrModelOpen, setIsOnVenOdrModelOpen]       = useState(false);
  const [isCustOnOrderModelOpen, setIsCustOnOrderModelOpen] = useState(false);
  const [isOrderQtyPopupOpen, setIsOrderQtyPopupOpen]       = useState(false);
  const [selectedItem, setSelectedItem]                     = useState(null);

  const [invLines, setInvLines]                         = useState([]);
  const [onOrderLines, setOnOrderLines]                 = useState([]);
  const [customerOnOrderLines, setCustomerOnOrderLines] = useState([]);
  const [isAccessible, setIsAccessible]                 = useState(false);

  const [view, setView] = useState(window.innerWidth <= 768 ? 1 : 2);
  const [customerCriteria] = useState(new CustomerATSInquiryCriteriaBean());
  // Order Date and Order Start Date default to today's date (YYYY-MM-DD, the
  // format DatePicker expects) so the user doesn't have to set them manually.
  const getTodayISO = () => new Date().toISOString().slice(0, 10);
  const [requestCriteria, setRequestCriteria] = useState(() => {
    const bean = new PortalSalesOrderBean();
    const today = getTodayISO();
    bean.orderDate      = today;
    bean.orderStartDate = today;
    return bean;
  });

  // ── Customer lookup state ──────────────────────────────────────────────────
  const customerCodeRef                                       = useRef(null);
  // Replaced external CustomerLookupHandler with inline CustomerLookupModal
  const [isCustomerLookupOpen, setIsCustomerLookupOpen]       = useState(false);
  const [customerPageListForAutoCompleteList, setCustomerPageListForAutoCompleteList] = useState([]);
  // Start as false — the dropdown must be hidden until the user actually types
  const [showAutoCompleteCustomerList, setShowAutoCompleteCustomerList] = useState(false);
  const [isCustomerNotFound, setIsCustomerNotFound]           = useState(false);
  // Stores the customer description returned by readCustomerWithChildren so
  // addSalesLine can set listRequest.customerName without a second service call.
  const [customerName, setCustomerName]                       = useState("");
 const [paymentTerms, setPaymentTerms]                       = useState("");
 const [paymentMethodCode, setPaymentMethodCode]                       = useState("");
 const [customerTypeCode, setCustomerTypeCode]                       = useState("");
 const [createdBy, setCreatedBy]                       = useState("");
  // ── Fabric/Item lookup state ───────────────────────────────────────────────
  const fabricStyleCodeRef                                              = useRef(null);
  // Replaced external FabricStyleLookupHandler with inline FabricStyleLookupModal
  const [isFabricLookupOpen, setIsFabricLookupOpen]                     = useState(false);
  const [fabricPageListForAutoCompleteList, setFabricPageListForAutoCompleteList] = useState([]);
  // Start as false — the dropdown must be hidden until the user actually types
  const [showAutoCompleteFabricCodeList, setShowAutoCompleteFabricCodeList] = useState(false);
  const [isAllowFabricRead, setIsAllowFabricRead]                       = useState(false);
  // const criteriaRef = useRef(null);

  // ── Color lookup state (mirrors SalesOrderMaintenanceModule colorList pattern) ──
  // Populated after readFabricByCode returns fabricStyle.colors
  const [colorList, setColorList]                                         = useState([]);
  
  
  const [showAutoCompleteColorList, setShowAutoCompleteColorList]         = useState(false);

    const [agingHistoryBean, setAgingHistorey] = useState([]);


  const isEntityUser = !isEmptyString(session?.entityCode);
    const [code, setCode] = useState("");

    const [fabric, setFabric] = useState([]);


  // ── auto-switch on resize ──────────────────────────────────────────────────
  useEffect(() => {
    const handleResize = () => setView(window.innerWidth <= 768 ? 1 : 2);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);


   useEffect(() => {
    if (!isEmpty(session)) {
      const { entityCode, code } = session;
      if (!isEmptyString(code)) setCode(code);
    }
    setFocus();
     asignDefault();
  }, []);
  const asignDefault = () => {

    const _criteria = new AllFabricATSInquiryCriteriaBean();
    _criteria.companyCode = process.env.REACT_APP_COMPANY;
    if (!isEmpty(session)) {

       
         
      const { entityCode } = session;
      if (!isEmptyString(entityCode)) {

        // criteria.customerCode  = entityCode;
        // console.log("requestCriteria",requestCriteria)
        // setCriteria(requestCriteria);
        _criteria.customerCode = entityCode;
        readCustomerByCode(entityCode)
      }
    }
    criteriaRef.current = _criteria;
    setCriteria(_criteria);
  };
  const listViewHandler = () => setView(1);
  const gridViewHandler = () => setView(2);

  // ── toast ──────────────────────────────────────────────────────────────────
  const notify = (type, msg, theme) => {
    if (type === 1) toast.info(msg, { theme });
    else if (type === 2) toast.error(msg, { theme });
    else if (type === 3) toast.success(msg, { theme });
    else if (type === 4) toast.warn(msg, { theme });
    else toast(msg);
  };

  const errorCallBack = (error) => {
    setIsLoading(false);
    notify(TOAST_ERROR, error.message);
  };

  // ── add sales line ─────────────────────────────────────────────────────────
  // Logic:
  //   1. Build a "header key" from the 5 header fields.
  //   2. If the header key matches the last one AND we already have a
  //      customerOrder ref → send that same customerOrder so the server
  //      appends the line to the existing order (no new order created).
  //   3. If the header key is different (or this is the very first click) →
  //      send customerOrder as null/empty so the server creates a NEW order,
  //      then store the returned customerOrder in the ref for future clicks.
  // const addSalesLine = (ln) => {
  //   console.log("addSalesLine", ln);

  //   const headerKey    = buildHeaderKey(requestCriteria, criteria.customerCode);
  //   const isSameHeader = headerKey === lastHeaderKeyRef.current;
  //   const existingRef  = isSameHeader ? currentCustomerOrderRef.current : null;

  //   // If the header changed, reset stored refs and clear the Sales Order Node
  //   if (!isSameHeader) {
  //     currentCustomerOrderRef.current = null;
  //     lastHeaderKeyRef.current        = headerKey;
  //     setSalesOrderLines([]);
  //     setSalesOrderNumber(null);
  //   }

  //   const listRequest = new PortalSalesOrderBean();

  //   // ── header fields ──────────────────────────────────────────────────────
  //   listRequest.companyCode  = process.env.REACT_APP_COMPANY;
  //   listRequest.customerCode = criteria.customerCode;

  //   listRequest.customerPurchaseOrderNumber = requestCriteria.customerPurchaseOrderNumber;
  //   listRequest.orderDate                   = requestCriteria.orderDate;
  //   listRequest.orderStartDate              = requestCriteria.orderStartDate;
  //   listRequest.orderStopDate               = requestCriteria.orderStopDate;

  //   // ── reuse existing customerOrder if header is unchanged ────────────────
  //   if (existingRef) {
  //     listRequest.customerOrder = existingRef;
  //     console.log("addSalesLine → reusing customerOrder:", existingRef);
  //   } else {
  //     console.log("addSalesLine → new header, server will create customerOrder");
  //   }

  //   // ── line details ───────────────────────────────────────────────────────
  //   listRequest.fabricStyleCode      = ln.fabricStyleCode;
  //   listRequest.fabricStyleColorCode = ln.fabricStyleColorCode;
  //   listRequest.lineDetails = JSON.stringify([
  //     {
  //       fabricStyleCode:      ln.fabricStyleCode,
  //       fabricStyleColorCode: ln.fabricStyleColorCode,
  //       orderQuantity:        ln.orderQuantity || 0,
  //       colorCode:            ln.colorCode,
  //       uomCode:              "YD",
  //       price:                ln.price || 0,
  //     },
  //   ]);

  //   // ── cache the full line object so handleSalesResponse can use it ───────
  //   pendingSalesLineRef.current = { ...ln };

  //   console.log("listRequest (final)", listRequest);
  //   service(token, "savePortalSalesOrder", listRequest, handleSalesResponse, errorCallBack);
  // };



const addSalesLine = (ln) => {

  
  
  
  // Always resolve the freshest row from atsInfos so that any orderQuantity
  // set via the OrderQtyPopup (which updates atsInfos state, not the card's
  // closed-over `ln`) is reflected in the Sales Order Node.
  const freshLn = atsInfos.find(
    (row) =>
      row.fabricStyleCode      === ln.fabricStyleCode &&
      row.fabricStyleColorCode === ln.fabricStyleColorCode
  ) || ln;

  // ── Guard: Order Qty must be set before adding to a sales order ───────────
  if (freshLn.orderQuantity == null || freshLn.orderQuantity <= 0) {
    notify(TOAST_ERROR, "Please enter Order Quantity before adding to the Sales Order.");
    return;
  }



  const headerKey    = buildHeaderKey(requestCriteria, criteria.customerCode);
  const isSameHeader = headerKey === lastHeaderKeyRef.current;
  const existingRef  = isSameHeader ? currentCustomerOrderRef.current : null;

  if (!isSameHeader) {
    currentCustomerOrderRef.current = null;
    lastHeaderKeyRef.current        = headerKey;
    setSalesOrderLines([]);
    setSalesOrderNumber(null);
  }

  const listRequest = new PortalSalesOrderBean();

  
  

  listRequest.companyCode  = process.env.REACT_APP_COMPANY;
  listRequest.customerCode = criteria.customerCode;
  // customerName is populated by readCustomerWithChildren when the user enters
  // or selects a customer code — no extra service call needed here.
  listRequest.customerName = customerName.description;
  listRequest.paymentTermCode = customerName.paymentTermsCode;
  listRequest.paymentMethodCode = customerName.paymentMethodCode;
  listRequest.customerTypeCode = customerName.customerTypeCode;
   listRequest.salesPersonCode = session.description;
  listRequest.customerPurchaseOrderNumber = requestCriteria.customerPurchaseOrderNumber;
  listRequest.orderDate                   = requestCriteria.orderDate;
  listRequest.orderStartDate              = requestCriteria.orderStartDate;
  listRequest.orderStopDate               = requestCriteria.orderStopDate;

  if (existingRef) {
    listRequest.customerOrder = existingRef;
  
  } else {
  
  }

  listRequest.fabricStyleCode      = freshLn.fabricStyleCode;
  listRequest.fabricStyleColorCode = freshLn.fabricStyleColorCode;

  // ── build lineDetails from ALL previously saved lines + the new line
  // When header is the same, salesOrderLines holds all lines saved so far.
  // When header changed (isSameHeader=false), salesOrderLines was just cleared
  // above, so this correctly sends only the new line for a fresh order.
  const existingLines = isSameHeader ? salesOrderLines : [];

  const allLines = [
    ...existingLines.map((l) => ({
      fabricStyleCode:      l.fabricStyleCode,
      // fabricSColorCode: l.fabricStyleColorCode,
      orderQuantity:        l.orderQuantity || 0,
      colorCode:            l.fabricStyleColorCode,
      uomCode:              "YD",
      price:                l.price || 0,
    })),
    {
      fabricStyleCode:      freshLn.fabricStyleCode,
      // fabricStyleColorCode: freshLn.fabricStyleColorCode,
      orderQuantity:        freshLn.orderQuantity || 0,
      colorCode:            freshLn.fabricStyleColorCode,
      uomCode:              "YD",
      price:                freshLn.price || 0,
    },
  ];

  listRequest.lineDetails = JSON.stringify(allLines);

  

  // Store the full freshLn object (including onHandQuantity, vendorOnOrderQuantity,
  // customerOnOrderQuantity) so handleSalesResponse can push it into salesOrderLines
  // with all quantity fields intact.
  pendingSalesLineRef.current = { ...freshLn };

 
  service(token, "savePortalSalesOrder", listRequest, handleSalesResponse, errorCallBack);
};


  const handleSalesResponse = (response) => {
   
    let msg_List = [];
    if (!isEmpty(response.data)) {
      if (response.data.isSessionExpired) {
        setisSessionExpeired(true);
      } else if (response.data.isSuccess) {
        // ── Store the customerOrder returned by the server ─────────────────
        const returnedOrder =
          response.data.portalSalesOrder?.customerOrder ||
          response.data.customerOrder ||
          null;

        if (returnedOrder && !currentCustomerOrderRef.current) {
          currentCustomerOrderRef.current = returnedOrder;
          setSalesOrderNumber(returnedOrder);
          
        }

        // ── Push the saved line into the Sales Order Node ──────────────────
        // Only add if we have the pending line snapshot and it is not a
        // duplicate (same style + color already in the node).
        const pendingLine = pendingSalesLineRef.current;
        if (pendingLine) {
          setSalesOrderLines((prev) => {
            const alreadyExists = prev.some(
              (l) =>
                l.fabricStyleCode      === pendingLine.fabricStyleCode &&
                l.fabricStyleColorCode === pendingLine.fabricStyleColorCode
            );
            return alreadyExists ? prev : [...prev, pendingLine];
          });
          // Auto-switch to Sales Order Node tab so the user sees the saved line
          setActiveNode("salesOrder");
          pendingSalesLineRef.current = null;

          // ── Clear the Item / Fabric and Color fields so the user can pick
          // the next item fresh instead of the just-added one lingering. ──
          setCriteria((prev) => {
            const next = { ...prev, fabricStyleCode: "", fabricStyleColorCode: "" };
            criteriaRef.current = next;
            return next;
          });
          setColorList([]);
          setShowAutoCompleteFabricCodeList(false);
          setShowAutoCompleteColorList(false);
        }

        if (!isEmptyArray(response.data.infos)) {
          response.data.infos.map((info) => msg_List.push(info.messageDescription));
          notify(TOAST_SUCESS, msg_List.toString());
        }
      } else {
        // On failure, discard the pending line reference
        pendingSalesLineRef.current = null;
        if (!isEmptyArray(response.data.errors)) {
          response.data.errors.map((error) => msg_List.push(error.messageDescription));
          notify(TOAST_ERROR, msg_List.toString());
        }
      }
    }
  };

  // ── Confirm Order ──────────────────────────────────────────────────────────
  // Calls the "confirmOrder" service with a RestReadRequest (companyCode only).
  // Can be triggered from a Sales Order Node line card OR from the list-view
  // Sales Order button against a specific line.
  const [confirmingOrderKey, setConfirmingOrderKey] = useState(null); // tracks which line is confirming

  const handleConfirmOrderResponse = (response) => {
  
    
    setConfirmingOrderKey(null);
    let msg_List = [];
    if (!isEmpty(response.data)) {
      if (response.data.isSessionExpired) {
        setisSessionExpeired(true);
      } else if (response.data.isSuccess) {
        if (!isEmptyArray(response.data.infos)) {
          response.data.infos.forEach((info) => msg_List.push(info.messageDescription));
        }
         setDisable(true)
        notify(TOAST_SUCESS, msg_List.length ? msg_List.toString() : "Order confirmed successfully.");
      } else {
        if (!isEmptyArray(response.data.errors)) {
          response.data.errors.forEach((error) => msg_List.push(error.messageDescription));
        }
        notify(TOAST_ERROR, msg_List.length ? msg_List.toString() : "Failed to confirm order.");
      }
    }
  };

  // lineKey — any unique string identifying the line being confirmed, used only
  // to set the loading indicator on the right button while the card is in-flight.
  const confirmOrder = (lineKey) => {
  
    setConfirmingOrderKey(lineKey);
    const request = new RestReadRequest();
    request.companyCode = process.env.REACT_APP_COMPANY;
       request.code=lineKey;
   
    service(token, "confirmOrder", request, handleConfirmOrderResponse, (error) => {
      setConfirmingOrderKey(null);
      errorCallBack(error);
    });
  };

  // ── Save Sales Order (persists any inline price edits) ─────────────────────
  // Rebuilds the listRequest from ALL lines currently in salesOrderLines —
  // including any Price the client edited via the Price CardRow — and saves it
  // through the same savePortalSalesOrder call used by "+ Add Sales", so the
  // modified price reaches the backend.
  const saveSalesOrder = () => {
    if (isEmptyArray(salesOrderLines)) return;

    const listRequest = new PortalSalesOrderBean();

    listRequest.companyCode  = process.env.REACT_APP_COMPANY;
    listRequest.customerCode = criteria.customerCode;
    listRequest.customerName = customerName.description;
    listRequest.paymentTermCode   = customerName.paymentTermsCode;
    listRequest.paymentMethodCode = customerName.paymentMethodCode;
    listRequest.customerTypeCode  = customerName.customerTypeCode;
    listRequest.salesPersonCode   = session.description;
    listRequest.customerPurchaseOrderNumber = requestCriteria.customerPurchaseOrderNumber;
    listRequest.orderDate                   = requestCriteria.orderDate;
    listRequest.orderStartDate              = requestCriteria.orderStartDate;
    listRequest.orderStopDate               = requestCriteria.orderStopDate;

    if (currentCustomerOrderRef.current) {
      listRequest.customerOrder = currentCustomerOrderRef.current;
    }

    // salesOrderLines already reflects any price edited inline (see
    // updateLinePrice), so mapping over it here always sends the latest value.
    const allLines = salesOrderLines.map((l) => ({
      fabricStyleCode: l.fabricStyleCode,
      orderQuantity:   l.orderQuantity || 0,
      colorCode:       l.fabricStyleColorCode,
      uomCode:         "YD",
      price:           l.price || 0,
    }));

    listRequest.lineDetails = JSON.stringify(allLines);

    service(
      token,
      "savePortalSalesOrder",
      listRequest,
      handleSalesResponse,
      errorCallBack
    );
  };

  // Persists any edited price(s) first, then proceeds with the normal
  // Confirm Order flow. Wired to the Sales Order Node's Confirm button.
  const saveAndConfirmOrder = (lineKey) => {
    saveSalesOrder();
    confirmOrder(lineKey);
  };

  // ── modal open/close ───────────────────────────────────────────────────────
  const openModal = (type, data) => {
 
    
    if (type === 1 && data.onHandQuantity > 0)          getInvLines(data);
    if (type === 2 && data.vendorOnOrderQuantity > 0)   getOnOrderLines(data);
    if (type === 3 && data.customerOnOrderQuantity > 0)    getCustomerOnOrderLines(data);
    //   {
    //   // setCustomerOnOrderLines(data.customerOnOrderLines || []);
    //   // setSelectedItem(data);
    //   //  getCustomerOnOrderLines(data);
    //   // setIsCustOnOrderModelOpen(true);
    // }
    if (type === 4) {
      // Do not allow editing Order Qty on an existing order opened from List View
      if (requestCriteria.customerOrderNumber) return;
      setSelectedItem(data);
      setIsOrderQtyPopupOpen(true);
    }
  };

  const closeModal = () => {
    setIsOnHandModelOpen(false);
    setIsOnVenOdrModelOpen(false);
    setIsCustOnOrderModelOpen(false);
    setIsOrderQtyPopupOpen(false);
    setSelectedItem(null);
  };

  // ── save Order Qty from manual popup ──────────────────────────────────────
  const handleSaveOrderQty = (item, qty) => {
    setAtsInfos((prev) =>
      prev.map((row) =>
        row.fabricStyleCode === item.fabricStyleCode &&
        row.fabricStyleColorCode === item.fabricStyleColorCode
          ? { ...row, orderQuantity: qty }
          : row
      )
    );
    // Also update the qty in the Sales Order Node if the line is already there
    setSalesOrderLines((prev) =>
      prev.map((row) =>
        row.fabricStyleCode === item.fabricStyleCode &&
        row.fabricStyleColorCode === item.fabricStyleColorCode
          ? { ...row, orderQuantity: qty }
          : row
      )
    );
  };

  // ── save Price edit from Fabric Details card ────────────────────────────
  // Called from the editable Price row in StyleCard (Fabric Details / Header
  // Node). Keeps atsInfos in sync so "+ Add Sales" (freshLn.price) always
  // picks up the latest edited value, and also updates salesOrderLines in
  // case this line was already added to the order, so saveSalesOrder() sends
  // the latest price to the backend.
  const handleStylePriceChange = (item, newPriceValue) => {
    const parsed = parseFloat(newPriceValue);
    const safePrice = isNaN(parsed) || parsed < 0 ? 0 : parsed;

    setAtsInfos((prev) =>
      prev.map((row) =>
        row.fabricStyleCode === item.fabricStyleCode &&
        row.fabricStyleColorCode === item.fabricStyleColorCode
          ? { ...row, price: safePrice }
          : row
      )
    );

    setSalesOrderLines((prev) =>
      prev.map((row) =>
        row.fabricStyleCode === item.fabricStyleCode &&
        row.fabricStyleColorCode === item.fabricStyleColorCode
          ? { ...row, price: safePrice }
          : row
      )
    );
  };

  // ── focus + lookup handler init ───────────────────────────────────────────
  const setFocus = () => {
    if (inputRef.current != null) inputRef.current.focus();
  };
  useEffect(() => {
    setFocus();
    // CustomerLookupModal and FabricStyleLookupModal are self-contained —
    // no external handler objects to initialise.
  }, []);

  // ── report ─────────────────────────────────────────────────────────────────
  const handleReportResponse = (response) => {
    let msg_List = [];
    if (response.data != null) {
      if (response.data.isSessionExpired) {
        setisSessionExpeired(true);
      } else if (response.data.isSuccess) {
        if (response.data.reportResult != null) {
          if (!isEmptyString(response.data.reportResult.reportFileID)) {
            window.open(
              `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_REPORT_PATH}` +
                response.data.reportResult.reportFileID
            );
          }
        }
        if (!isEmptyArray(response.data.infos)) {
          response.data.infos.map((info) => msg_List.push(info.messageDescription));
          notify(TOAST_SUCESS, msg_List.toString());
        }
      } else {
        if (!isEmptyArray(response.data.errors)) {
          response.data.errors.map((error) => msg_List.push(error.messageDescription));
          notify(TOAST_ERROR, msg_List.toString());
        }
      }
    }
    setIsLoading(false);
  };

  const generateReport = (type) => {
    const request = new BatchInventorySummaryDataPrintRequest();
    criteria.companyCode = process.env.REACT_APP_COMPANY;
    if (!isEmpty(session)) {
      const { entityCode, code } = session;
      if (!isEmptyString(entityCode)) criteria.logisticCustomerCode = entityCode;
      if (!isEmptyString(code)) criteria.customerUserCode = code;
    }
    const reportBean = new RestReportBean();
    reportBean.reportType = type;
    request.criteria  = criteria;
    request.reportBean = reportBean;
    service(token, "generateItemSkuInventoryDetailsPrintReport", request, handleReportResponse, errorCallBack);
  };

  const PDFHandler = () => {
    if (SecurityAccessManager.ItemSkuInventoryDetailsPDFReport_IsAccessible()) {
      setIsLoading(true);
      generateReport(1);
    } else {
      setIsAccessible(true);
    }
  };

  const ExcelHandler = () => {
    if (SecurityAccessManager.ItemSkuInventoryDetailsInquiryExcelReport_IsAccessible()) {
      setIsLoading(true);
      generateReport(2);
    } else {
      setIsAccessible(true);
    }
  };

  const ResetHandler = () => {
    // ── 1. Reset ATS search criteria (Item / Color) ────────────────────────
    const resetCriteria = new AllFabricATSInquiryCriteriaBean();
    setCriteria(resetCriteria);
    criteriaRef.current = resetCriteria;

    // ── 2. Reset header / order criteria (PO#, OrderNo, dates) ───────────
    // Order Date / Order Start Date default back to today's date rather than
    // being left blank.
    const resetHeader = new PortalSalesOrderBean();
    const todayOnReset = getTodayISO();
    resetHeader.orderDate      = todayOnReset;
    resetHeader.orderStartDate = todayOnReset;
    setRequestCriteria(resetHeader);

    // ── 3. Reset all list + view state ────────────────────────────────────
    setAtsInfos([]);
    setDisable(false);
    setIsShowExcel(false);
    setIsShowPdf(false);

    // ── 4. Reset Sales Order Node ─────────────────────────────────────────
    setSalesOrderLines([]);
    setSalesOrderNumber(null);
    setPortalSalesOrders([]);
    setIsListView(false);
    setActiveNode("header");
    currentCustomerOrderRef.current = null;
    lastHeaderKeyRef.current        = null;
    pendingSalesLineRef.current     = null;

    // ── 5. Reset customer lookup state ────────────────────────────────────
    setCustomerName("");
    setPaymentTerms("");
    setPaymentMethodCode("");
    setCustomerTypeCode("");
    setCreatedBy("");
    setIsCustomerNotFound(false);
    setCustomerPageListForAutoCompleteList([]);
    setShowAutoCompleteCustomerList(false);

    // ── 6. Reset fabric lookup state ──────────────────────────────────────
    setFabricPageListForAutoCompleteList([]);
    setShowAutoCompleteFabricCodeList(false);
    setIsAllowFabricRead(false);

    // ── 7. Reset color lookup state ───────────────────────────────────────
    setColorList([]);
    setShowAutoCompleteColorList(false);

    setFocus();
  };

  // ── main data fetch ────────────────────────────────────────────────────────
  const handleResponse = (response) => {
  
    let msg_List = [];
    if (!isEmpty(response.data)) {
      if (response.data.isSessionExpired) {
        setisSessionExpeired(true);
      } else if (response.data.isSuccess) {
        if (!isEmpty(response.data.inquiryResult) && !isEmptyArray(response.data.inquiryResult.atsInfos)) {
          const result = response.data.inquiryResult;

          // ✅ Set records from server
          setAtsInfos(result.atsInfos);

          // ✅ Read ALL pagination values directly from server's PageListBean
          // FabricStyleCurrentATSResultBean extends PageListBean, so
          // result.pageSize, result.currentPage, result.totalCount are all available.
          const serverPageSize   = result.pageSize    || 20;
          const serverPage       = result.currentPage || 1;
          const serverTotalCount = result.totalCount  || 0;

          // ✅ Update state — no hardcoded values anywhere
          setPageSize(serverPageSize);
          setPage(serverPage);                                          // updates pageRef too
          setTotalCount(serverTotalCount);
          setMaxPage(Math.ceil(serverTotalCount / serverPageSize));     // updates maxPageRef too

          // setIsShowExcel(true);
          // setIsShowPdf(true);

     ;

          if (!isEmptyArray(response.data.infos)) {
            response.data.infos.map((info) => msg_List.push(info.messageDescription));
            notify(TOAST_SUCESS, msg_List.toString());
          }
        }
        if (!isEmpty(response.data.inquiryResult) && isEmptyArray(response.data.inquiryResult.atsInfos)) {
          notify(TOAST_WARN, "No Data Found");
        }
      } else {
        if (!isEmptyArray(response.data.errors)) {
          response.data.errors.map((error) => msg_List.push(error.messageDescription));
          notify(TOAST_ERROR, msg_List.toString());
        }
      }
    }
    setIsLoading(false);
  };


  const loadPage = (id) => {
    if (SecurityAccessManager.ItemSkuInventoryDetailsInquiry_IsAccessible()) {
      setAtsInfos([]);
      setIsLoading(true);
      // Always read from criteriaRef, NOT from the `criteria` state closure.
      // When loadPage is triggered immediately after setCriteria() (e.g. from
      // handleOrderNumberClick), React has not yet re-rendered so `criteria`
      // still holds the previous render's stale value. criteriaRef.current is
      // updated synchronously inside setCriteria's updater, so it is always fresh.
      const activeCriteria = criteriaRef.current;
      activeCriteria.companyCode     = process.env.REACT_APP_COMPANY;
      activeCriteria.fabricStyleCode = fabric.code;

      // ✅ Always read from pageSizeRef — never stale like the state value
      const pageInput        = new PageListBean();
      pageInput.currentPage   = id;                  // which page to fetch
      pageInput.pageSize     = pageSizeRef.current; // ✅ always 20, never stale

      const listRequest          = new RestFabricStyleATSListRequest();
      listRequest.searchCriteria = activeCriteria;
      listRequest.pageInput      = pageInput;

     
      service(token, "inquireAllFabricStyleATSInfo_v1", listRequest, handleResponse, errorCallBack);
    } else {
      setIsAccessible(true);
    }
  };

  // ✅ Navigation functions read from refs — never stale closure values
  const loadFirst    = () => loadPage(1);
  const loadLast     = () => loadPage(maxPageRef.current);
  const loadNext     = () => {
   
    if (maxPageRef.current > pageRef.current) loadPage(pageRef.current + 1);
  };
  const loadPrevious = () => {
   
    if (pageRef.current > 1) loadPage(pageRef.current - 1);
  };

  // ── Enter-key field-to-field focus navigation ────────────────────────────
  // Each field calls enterKeyHandler(fieldName) on Enter; focus advances to the
  // next field in the sequence.  The Fetch button is triggered separately via
  // the "Fetch" CustomButton or by pressing Enter while the fetch button is focused.
  const FIELD_SEQUENCE = [
    "customerCode",
    "customerPurchaseOrderNumber",
    "orderDate",
    "orderStartDate",
    "orderStopDate",
    "fabricStyleCode",
    "fabricStyleColorCode",
    "fetchButton",
  ];

  const FIELD_REF_MAP = {
    customerCode:                 customerCodeRef,
    customerPurchaseOrderNumber:  poNumberRef,
    orderDate:                    orderDateRef,
    orderStartDate:               orderStartDateRef,
    orderStopDate:                orderStopDateRef,
    fabricStyleCode:              fabricStyleCodeRef,
    fabricStyleColorCode:         colorCodeRef,
    fetchButton:                  fetchButtonRef,
  };

  const enterKeyHandler = (fieldName) => {
    
    const currentIndex = FIELD_SEQUENCE.indexOf(fieldName);
    
    if (currentIndex === -1) return;
    const nextField = FIELD_SEQUENCE[currentIndex + 1];
    if (nextField) {
      focusRef(FIELD_REF_MAP[nextField]);
    }
  };
  const buttonHandler = () => {
    if (!criteria.fabricStyleCode || criteria.fabricStyleCode.trim() === "") {
      notify(TOAST_ERROR, "Please enter Fabric Detail.");
      return;
    }
    setActiveNode("header")
    loadFirst();
  };
  const buttonSaveHandler =()=>{
    // ── Mandatory field validation ─────────────────────────────────────────
    if (!criteria.customerCode || criteria.customerCode.trim() === "") {
      notify(TOAST_ERROR, "Customer is required.");
      return;
    }
    if (!requestCriteria.customerPurchaseOrderNumber || requestCriteria.customerPurchaseOrderNumber.trim() === "") {
      notify(TOAST_ERROR, "Customer PO Number is required.");
      return;
    }
    if (!requestCriteria.orderDate || requestCriteria.orderDate.trim() === "") {
      notify(TOAST_ERROR, "Order Date is required.");
      return;
    }
    if (!requestCriteria.orderStartDate || requestCriteria.orderStartDate.trim() === "") {
      notify(TOAST_ERROR, "Order Start Date is required.");
      return;
    }
    if (!requestCriteria.orderStopDate || requestCriteria.orderStopDate.trim() === "") {
      notify(TOAST_ERROR, "Order Stop Date is required.");
      return;
    }

    const activeCriteria = criteriaRef.current;
      activeCriteria.companyCode = process.env.REACT_APP_COMPANY;
      // const pageInput    = new RestPageListBean();
      const listRequest  = new PortalSalesOrderBean();
      listRequest.companyCode = activeCriteria.companyCode
      listRequest.customerCode = customerName.code;
        listRequest.customerName = customerName.description;
  listRequest.paymentTermCode = customerName.paymentTermsCode;
  listRequest.paymentMethodCode = customerName.paymentMethodCode;
  listRequest.customerTypeCode = customerName.customerTypeCode;
   listRequest.customerPurchaseOrderNumber = requestCriteria.customerPurchaseOrderNumber;
  listRequest.orderDate                   = requestCriteria.orderDate;
  listRequest.orderStartDate              = requestCriteria.orderStartDate;
  listRequest.orderStopDate               = requestCriteria.orderStopDate;

     listRequest.salesPersonCode = session.description
      service(token, "savePortalSalesOrderHeader", listRequest, handleSaveResponse, errorCallBack);
  }

const handleSaveResponse = (response) =>{

  

}

  const onChange = (e) => {
    const { name, value, type, checked } = e.target;
    const inputValue = type === "checkbox" ? checked : value;
    if (name === "customerCode") {
      currentCustomerOrderRef.current = null;
      lastHeaderKeyRef.current        = null;
    }
    setCriteria((prevState) => {
      const next = {
        ...prevState,
        [name]: type === "number" ? parseFloat(inputValue).toFixed(2) : inputValue,
      };
      criteriaRef.current = next;   // keep ref in sync with state
      return next;
    });
  };

  const onChanges = (e) => {
    const { name, value, type, checked } = e.target;
    const inputValue = type === "checkbox" ? checked : value;
    currentCustomerOrderRef.current = null;
    lastHeaderKeyRef.current        = null;
    setRequestCriteria((prevState) => ({
      ...prevState,
      [name]: type === "number" ? parseFloat(inputValue).toFixed(2) : inputValue,
    }));
  };

  // ── Customer lookup handlers ───────────────────────────────────────────────
  const onCustomerCodeChange = (e) => {
    const customerCode = e.target.value.toUpperCase();
    if (!customerCode) {
      // Field cleared — hide dropdown, reset not-found flag, clear order session
      setShowAutoCompleteCustomerList(false);
      setCustomerPageListForAutoCompleteList([]);
      setIsCustomerNotFound(false);
      setCustomerName("");
      currentCustomerOrderRef.current = null;
      lastHeaderKeyRef.current = null;
    } else {
      // Characters typed — show dropdown and kick off the search-as-you-type call
      setShowAutoCompleteCustomerList(true);
      readCustomerBySearchString(e.target.value);
      // Reset order session whenever the customer code changes
      currentCustomerOrderRef.current = null;
      lastHeaderKeyRef.current = null;
    }
    setCriteria((prev) => {
      const next = { ...prev, [e.target.name]: customerCode };
      criteriaRef.current = next;
      return next;
    });
  };

  const customerCodeEnterKeyEventHandler = (e) => {
    readCustomerByCode(e.target.value);
    setCustomerPageListForAutoCompleteList([]);
    setShowAutoCompleteCustomerList(false);
    // Advance focus to the next field in the sequence
    enterKeyHandler("customerCode");
  };

  // Called when user picks a row inside CustomerLookupModal
  const onCustomerLookupSelect = (item) => {
    setCriteria((prev) => {
      const next = { ...prev, customerCode: item.code };
      criteriaRef.current = next;
      return next;
    });
    setIsCustomerNotFound(false);
    setCustomerPageListForAutoCompleteList([]);
    setShowAutoCompleteCustomerList(false);
    currentCustomerOrderRef.current = null;
    lastHeaderKeyRef.current        = null;
    // Validate/load the selected customer via readCustomerWithChildren
    readCustomerByCode(item.code);
  };

  const displayAutoCompleteCustomerList = (show) => {
    setShowAutoCompleteCustomerList(show);
  };

  const readCustomerBySearchString = (searchString) => {
    const searchCriteria = new CustomerSearchCriteria();
    searchCriteria.companyCode = process.env.REACT_APP_COMPANY;
    // Match by code prefix OR name — uppercase so the server index is hit correctly
    searchCriteria.customerCodeStartsWith = searchString.toUpperCase();
    searchCriteria.customerNameContains   = searchString;
    const pageInput = new RestCustomerListRequest();
    pageInput.pageInput          = new PageListBean();
    pageInput.pageInput.pageSize = 100;
    pageInput.searchCriteria     = searchCriteria;
    service(
      token,
      "getCustomerPageList",
      pageInput,
      (response) => {
        const customers = response?.data?.customerPageList?.customers || [];
        const list = customers
        //  .filter((c) => c.Status === "A")
        .filter((c) => c.Status === "A" || c.status === "A")
        .map((c) => ({ code: c.code, description: c.description }));
        setCustomerPageListForAutoCompleteList(list);
      },
      // Search-as-you-type errors should not flag the field as not-found —
      // that is only done by readCustomerByCode (triggered on Enter / selection).
      () => setCustomerPageListForAutoCompleteList([]),
    );
  };

  // readCustomerByCode — called on Enter in the Customer textbox.
  // Uses readCustomerWithChildren (mirrors readCustomer() in SalesOrderMaintenanceModule):
  //   • Builds a RestReadRequest with companyCode, code, isLoadChildren=true
  //   • Calls CustomerService.readCustomerWithChildren
  //   • On success: reads response.data.customer, sets isCustomerNotFound based on
  //     active status (matches readCustomerResponse in maintenance module)
  //   • On error: marks customer as not found
  const readCustomerByCode = (customerCode) => {
    if (!customerCode) return;
    const readRequest = new RestReadRequest();
    readRequest.companyCode   = process.env.REACT_APP_COMPANY;
    readRequest.code          = customerCode.toUpperCase();
    readRequest.isLoadChildren = true;
     service(token,"readCustomerWithChildren",readRequest,
      (response) => {
        const customerData = response?.data?.customer;
        if (customerData) {
          // Inactive customers are flagged as "not found" — mirrors readCustomerResponse
          const isInactive = customerData.isActive === false;
          setIsCustomerNotFound(isInactive);
          if (isInactive) {
            notify(TOAST_WARN, "Customer is InActive");
            setCustomerName("");
            setPaymentTerms("");
            setPaymentMethodCode("");
            setCustomerTypeCode("");
             setCreatedBy("");
          } else {
            // Persist the name so addSalesLine can populate listRequest.customerName
            // setCustomerName(customerData.description || "");
            // setPaymentTerms(customerData.paymentTermsCode || "");
            // setPaymentMethodCode(customerData.paymentMethodCode || "");
            //  setCustomerTypeCode(customerData.customerTypeCode || "");
            // setCreatedBy(customerData.createdBy || "");
           
           setCustomerName(customerData);

          }
        } else {
          setIsCustomerNotFound(true);
          setCustomerName("");
           setPaymentTerms("");
            setPaymentMethodCode("");
            setCustomerTypeCode("");
               setCreatedBy("");

        }
      },
      () => { setIsCustomerNotFound(true); setCustomerName(""); },
    );
  };

  // ── Fabric/Item lookup handlers ────────────────────────────────────────────
  const onFabricCodeChange = (e) => {
    const fabricStyleCode = e.target.value.toUpperCase();
    if (!fabricStyleCode) {
      // Field cleared — hide dropdown
      setShowAutoCompleteFabricCodeList(false);
      setFabricPageListForAutoCompleteList([]);
      setIsAllowFabricRead(false);
    } else {
      // Characters typed — show dropdown and kick off the search-as-you-type call
      setShowAutoCompleteFabricCodeList(true);
      readFabricBySearchString(fabricStyleCode);   // pass the already-uppercased value
      setIsAllowFabricRead(false);
    }
    setCriteria((prev) => {
      const next = { ...prev, [e.target.name]: fabricStyleCode };
            if (!fabricStyleCode) {
        // Item/Fabric cleared — clear the corresponding color code too
        next.fabricStyleColorCode = "";
      }

      criteriaRef.current = next;
      return next;
    });
  };

  const onfabricBlur = (e) => {
    // On blur, do a direct style read to validate the typed code —
    // mirrors the readandsetFabricStyleDetail call triggered by blur in
    // SalesOrderMaintenanceModule (the same RestReadRequest / readFabricStyle flow).
    setTimeout(() => {
      if (!isAllowFabricRead && e.target.value) {
        readFabricByCode(e.target.value);
      }
    }, 100);
  };

  const onfabricKeyDown = (e) => {
    // F2 (113) or Escape (27) — allow direct read, suppress blur autocomplete
    if (e.keyCode === 113 || e.keyCode === 27) {
      setIsAllowFabricRead(true);
    }
  };

  const fabricenterKeyEventHandler = (e) => {

    
    const fabricStyleCode = e.target.value;
    setShowAutoCompleteFabricCodeList(false);
    setFabricPageListForAutoCompleteList([]);
    setIsAllowFabricRead(false);
    setCriteria((prev) => {
      const next = { ...prev, fabricStyleCode: fabricStyleCode.toUpperCase() };
      criteriaRef.current = next;
      return next;
    });
    // On Enter, do a direct read via readFabricStyle to validate the code —
    // mirrors fabricenterKeyEventHandler → readandsetFabricStyleDetail in
    // SalesOrderMaintenanceModule.
    if (fabricStyleCode) readFabricByCode(fabricStyleCode);
    // Advance focus to the Color field
    enterKeyHandler("fabricStyleCode");
  };

  // Called when user picks a row inside FabricStyleLookupModal
  const onFabricLookupSelect = (item) => {
    
    setCriteria((prev) => {
      const next = { ...prev, fabricStyleCode: item.code };
      criteriaRef.current = next;
      return next;
    });
    setFabricPageListForAutoCompleteList([]);
    setShowAutoCompleteFabricCodeList(false);
    setIsAllowFabricRead(false);
    readFabricByCode(item.code);
  };
  // Mirrors readandsetFabricStyleDetail() in SalesOrderMaintenanceModule:
  //   • Builds RestReadRequest with companyCode, code, isLoadChildren=true
  //   • Calls FabricStyleService.readFabricStyle
  //   • On success: reads response.data.fabricStyle to confirm the style exists
  //   • On error: silently clears the autocomplete list (no blocking alert)
  const readFabricByCode = (fabricStyleCode) => {
    if (!fabricStyleCode) return;
    const input = new RestReadRequest();
    input.companyCode   = process.env.REACT_APP_COMPANY;
    input.code          = fabricStyleCode.toUpperCase();
    input.isLoadChildren = true;
    service(token,"readFabricStyle",
      input,
      (response) => {
        
        const fabricStyle = response?.data?.fabricStyle;
        if (!fabricStyle) {
          setFabricPageListForAutoCompleteList([]);
          setColorList([]);
          setShowAutoCompleteColorList(false);
          return;
        }
        // ── Populate color dropdown from fabricStyle.colors ────────────────
        // Mirrors fabricStyleSelected() in SalesOrderMaintenanceModule:
        //   builds a list of { code, description } from active colors.
        const colors = fabricStyle.colors || [];
        const activeColors = colors
          // .filter((c) => c.isActive)
          .map((c) => ({
            code:        c.fabricStyleColorCode,
            description: c.fabricStyleColorName || c.fabricStyleColorCode,
          }));

          setFabric(fabricStyle);

        if (activeColors.length === 1) {
          // Auto-select the only active color
          setCriteria((prev) => {
            const next = { ...prev, fabricStyleColorCode: activeColors[0].code };
            criteriaRef.current = next;
            return next;
          });
          setColorList([]);
          setShowAutoCompleteColorList(false);
        } else {
          setColorList(activeColors);
          // Show the dropdown only if there are multiple colors and no value typed yet
          setShowAutoCompleteColorList(activeColors.length > 0);
        }
      },
      (error) => {
        setFabricPageListForAutoCompleteList([]);
        setColorList([]);
        notify(TOAST_ERROR, error.message);
      },
    );
  };

  const displayAutoCompleteFabricCodeList = (show) => {
    setShowAutoCompleteFabricCodeList(show);
  };

  const readFabricBySearchString = (searchString) => {
    const searchCriteria = new FabricStyleSearchCriteria();
    searchCriteria.companyCode = process.env.REACT_APP_COMPANY;
    // Code prefix must be uppercase to hit the server index; name search is case-tolerant
    searchCriteria.fabricStyleCodeStartsWith = searchString.toUpperCase();
    searchCriteria.fabricStyleNameStartsWith = searchString;
    const pageInput = new PageListBean();
    pageInput.pageSize = 100;
    const input = new RestFabricStyleListBeanRequest();
    input.companyCode    = process.env.REACT_APP_COMPANY;
    input.pageInput      = pageInput;
    input.code           = searchString.toUpperCase();
    input.searchCriteria = searchCriteria;
    service(
      token,
      "getActiveFabricStylesForAutoComplete",
      input,
      (response) => {
        const styles = response?.data?.fabricStylePageList?.fabricStyles || [];
        const list = styles
          .filter((s) => s.isActive)
          .map((s) => ({ code: s.fabricStyleCode, description: s.fabricStyleName }));
        setFabricPageListForAutoCompleteList(list);
      },
      // Search-as-you-type errors should clear silently, not toast the user
      () => setFabricPageListForAutoCompleteList([]),
    );
  };

  // ── inv lines modal ────────────────────────────────────────────────────────
  const handleInvLinesResponse = (response) => {
    let msg_List = [];
    if (!isEmpty(response.data)) {
      if (response.data.isSessionExpired) {
        setisSessionExpeired(true);
      } else if (response.data.isSuccess) {
        if (!isEmpty(response.data.skuBatchInventoryPageList) && !isEmptyArray(response.data.skuBatchInventoryPageList.skuBatchInventories)) {
          setInvLines(response.data.skuBatchInventoryPageList.skuBatchInventories);
          setIsOnHandModelOpen(true);
        }
        if (!isEmptyArray(response.data.infos)) {
          response.data.infos.map((info) => msg_List.push(info.messageDescription));
          notify(TOAST_SUCESS, msg_List.toString());
        }
      } else {
        if (!isEmptyArray(response.data.errors)) {
          response.data.errors.map((error) => msg_List.push(error.messageDescription));
          notify(TOAST_ERROR, msg_List.toString());
        }
      }
    }
    setIsLoading(false);
  };

  const getInvLines = (data) => {
    if (SecurityAccessManager.SkuBatchInventoryInquiry_IsAccessible()) {
      setIsLoading(true);
      const request = new RestSkuBatchInventoryListRequest();
      const crit    = new SKUBatchInventorySearchCriteria();
      crit.companyCode                     = process.env.REACT_APP_COMPANY;
      crit.fabricStyleCode                 = data.fabricStyleCode;
      crit.colorCode                       = data.fabricStyleColorCode;
      crit.isExcludeNonWarehouseInventory  = true;
      crit.fetchQuantityAvailableLinesOnly = true;
      request.searchCriteria = crit;
      request.pageInput      = new PageListBean();
      service(token, "getSkuBatchInventoryPageList", request, handleInvLinesResponse, errorCallBack);
    } else {
      setIsAccessible(true);
    }
  };

  // ── on-order lines modal ───────────────────────────────────────────────────
  const handleOnOrderLinesResponse = (response) => {
    let msg_List = [];
    if (!isEmpty(response.data)) {
      if (response.data.isSessionExpired) {
        setisSessionExpeired(true);
      } else if (response.data.isSuccess) {
        if (!isEmpty(response.data.orderDetailsResult) && !isEmptyArray(response.data.orderDetailsResult.onOrderInfoDetails)) {
          setOnOrderLines(response.data.orderDetailsResult.onOrderInfoDetails);
          setIsOnVenOdrModelOpen(true);
        }
        if (!isEmptyArray(response.data.infos)) {
          response.data.infos.map((info) => msg_List.push(info.messageDescription));
          notify(TOAST_SUCESS, msg_List.toString());
        }
      } else {
        if (!isEmptyArray(response.data.errors)) {
          response.data.errors.map((error) => msg_List.push(error.messageDescription));
          notify(TOAST_ERROR, msg_List.toString());
        }
      }
    }
    setIsLoading(false);
  };

  const getOnOrderLines = (data) => {
    setIsLoading(true);
    const request = new RestVendorPurchaseOnOrderListRequest();
    const crit    = new VendorPurchaseOnOrderSearchCriteria();
    crit.companyCode     = process.env.REACT_APP_COMPANY;
    crit.fabricStyleCode = data.fabricStyleCode;
    crit.colorCode       = data.fabricStyleColorCode;
    request.searchCriteria = crit;
    request.pageInput      = new PageListBean();
    service(token, "getVendorPurchaseOnOrderDetailsForFabricStyleStatistics", request, handleOnOrderLinesResponse, errorCallBack);
  };

  const getCustomerOnOrderLines = (data)=>{
  
    
    setIsLoading(true);
    const request = new RestCustomerSalesOnOrderListRequest();
    const crit    = new CustomerSalesOnOrderSearchCriteria();
    crit.companyCode     = process.env.REACT_APP_COMPANY;
    crit.fabricStyleCode = data.fabricStyleCode;
    crit.colorCode       = data.fabricStyleColorCode;
    request.searchCriteria = crit;
    request.pageInput      = new PageListBean();
    service(token, "getCustomerSalesOnOrderDetailsForFabricStyleStatistics", request, handleOnOrderCustomerLinesResponse, errorCallBack);
  }

  const handleOnOrderCustomerLinesResponse=(response)=>{

    
    let msg_List = [];
    if (!isEmpty(response.data)) {
      if (response.data.isSessionExpired) {
        setisSessionExpeired(true);
      } else if (response.data.isSuccess) {
        if (!isEmpty(response.data.orderDetailsResult) && !isEmptyArray(response.data.orderDetailsResult.onOrderInfoDetails)) {
          setCustomerOnOrderLines(response.data.orderDetailsResult.onOrderInfoDetails);
          setIsCustOnOrderModelOpen(true);
        }
        if (!isEmptyArray(response.data.infos)) {
          response.data.infos.map((info) => msg_List.push(info.messageDescription));
          notify(TOAST_SUCESS, msg_List.toString());
        }
      } else {
        if (!isEmptyArray(response.data.errors)) {
          response.data.errors.map((error) => msg_List.push(error.messageDescription));
          notify(TOAST_ERROR, msg_List.toString());
        }
      }
    }
    setIsLoading(false);
  }

  const onClose = () => setIsAccessible(false);

  // ── List-view toggle + fetch ───────────────────────────────────────────────
  const getModuleListView = () => {
    setIsListView((prev) => {
      const next = !prev;
      if (next) loadSalesPersonList();
      return next;
    });
  };

  const loadSalesPersonList = () => {
    setIsLoading(true);
    const listRequest  = new RestPortalSalesOrderRequest();
    const searchCriteria = new PortalSalesOrderSearchCriteria();
    const pageInput    = new PageListBean();

    searchCriteria.companyCode = process.env.REACT_APP_COMPANY;
    // Pass current form values so the list is scoped to the active search
    // searchCriteria.customerCode                = criteria.customerCode                         || undefined;
    searchCriteria.fabricStyleCode             = criteria.fabricStyleCode                      || undefined;
    searchCriteria.fabricStyleColorCode        = criteria.fabricStyleColorCode                 || undefined;
    searchCriteria.customerPurchaseOrderNumber = requestCriteria.customerPurchaseOrderNumber   || undefined;
    // searchCriteria.customerOrderNumber         = requestCriteria.customerOrderNumber           || undefined;
    searchCriteria.orderDate                   = requestCriteria.orderDate                     || undefined;
    searchCriteria.orderStartDate              = requestCriteria.orderStartDate                || undefined;
    searchCriteria.orderStopDate               = requestCriteria.orderStopDate                 || undefined;

    listRequest.companyCode = process.env.REACT_APP_COMPANY;
    listRequest.criteria    = searchCriteria;
    listRequest.pageList    = pageInput;

   
    service(token, "getPortalSalesOrderPageList", listRequest, handleReadSalesResponse, errorCallBack);
  };

  const handleReadSalesResponse = (response) => {
   
    let msg_List = [];
    if (!isEmpty(response.data)) {
      if (response.data.isSessionExpired) {
        setisSessionExpeired(true);
      } else if (response.data.isSuccess) {
        // portalSalesOrderPageList is the wrapper object; the array lives inside it
        const pageList = response.data.portalSalesOrderPageList;
        const orders   =
          (pageList && Array.isArray(pageList.portalSalesOrders) ? pageList.portalSalesOrders : null) ||
          (Array.isArray(pageList) ? pageList : null) ||
          [];
        setPortalSalesOrders(orders);

        if (!isEmptyArray(response.data.infos)) {
          response.data.infos.forEach((info) => msg_List.push(info.messageDescription));
          notify(TOAST_SUCESS, msg_List.toString());
        }
        if (orders.length === 0) {
          notify(TOAST_WARN, "No Sales Orders Found");
        }
      } else {
        if (!isEmptyArray(response.data.errors)) {
          response.data.errors.forEach((error) => msg_List.push(error.messageDescription));
          notify(TOAST_ERROR, msg_List.toString());
        }
      }
    }
    setIsLoading(false);
  };

  // ── Date normaliser ───────────────────────────────────────────────────────
  // The server may return dates as "MM/DD/YYYY", "M/D/YYYY", "YYYY-MM-DD", or
  // other locale-dependent strings.  DatePicker expects "YYYY-MM-DD".
  // This helper converts any of those variants to "YYYY-MM-DD" so the picker
  // renders the correct value.  Returns "" for null / unrecognised input.
  const normaliseDate = (raw) => {
    if (!raw) return "";
    const s = String(raw).trim();
    // Already ISO format YYYY-MM-DD (possibly with time component)
    if (/^\d{4}-\d{2}-\d{2}/.test(s)) return s.slice(0, 10);
    // MM/DD/YYYY or M/D/YYYY
    const slashParts = s.split("/");
    if (slashParts.length === 3) {
      const [m, d, y] = slashParts;
      if (y.length === 4) {
        return `${y}-${m.padStart(2, "0")}-${d.padStart(2, "0")}`;
      }
    }
    // DD-MM-YYYY or DD.MM.YYYY
    const dashParts = s.split(/[-\.]/);
    if (dashParts.length === 3 && dashParts[2].length === 4) {
      const [d, m, y] = dashParts;
      return `${y}-${m.padStart(2, "0")}-${d.padStart(2, "0")}`;
    }
    // Fallback: try native Date parse and reformat
    const dt = new Date(s);
    if (!isNaN(dt.getTime())) {
      return dt.toISOString().slice(0, 10);
    }
    return "";
  };

  // ── Date display formatter (MM/DD/YYYY) ──────────────────────────────────
  // Converts any server date string to MM/DD/YYYY for display in list/card view.
  // Returns "—" for null / unrecognised input.
  const formatDateMMDDYYYY = (raw) => {
    if (!raw) return "—";
    const iso = normaliseDate(raw); // normalises to YYYY-MM-DD
    if (!iso) return "—";
    const [y, m, d] = iso.split("-");
    if (!y || !m || !d) return "—";
    return `${m}/${d}/${y}`;
  };

  // ── Customer Order Number hyperlink click ─────────────────────────────────
  // WHY THE ITEM TEXTBOX WAS EMPTY:
  //   loadPage() reads from `criteria` — a React state value captured in the
  //   closure at render time. setCriteria() only schedules an update; it does
  //   NOT change `criteria` synchronously. So when setTimeout(buttonRef.click)
  //   fired loadPage on the next tick, `criteria` was still the old object with
  //   fabricStyleCode / fabricStyleColorCode empty (they were never populated
  //   from the order's lineDetails either).
  //
  // FIX:
  //   1. Parse lineDetails and extract fabricStyleCode + colorCode from the
  //      saved lines — these are the Item/Color values the ATS fetch needs.
  //   2. Build a complete fresh criteria object and write it to criteriaRef
  //      SYNCHRONOUSLY before calling loadFirst(). loadPage now reads from
  //      criteriaRef, so it always gets the latest value regardless of whether
  //      React has re-rendered yet.
  //   3. Call loadFirst() directly (no setTimeout, no buttonRef.click hack).
  const handleConfirmOrderClick =(order)=>{
     
  
     
       const listRequest  = new RestReadRequest();
        listRequest.companyCode = process.env.REACT_APP_COMPANY;
        listRequest.code=order.customerOrder
       
        
        service(token, "confirmOrder", listRequest, handleReadSalesConfirmResponse, errorCallBack);
  }
const handleReadSalesConfirmResponse=(response)=>{

  
}
  const handleOrderNumberClick = (order) => {

    // ── 1. Normalise server dates to YYYY-MM-DD for DatePicker ──────────────
    const normOrderDate      = normaliseDate(order.orderDate);
    const normOrderStartDate = normaliseDate(order.orderStartDate);
    const normOrderStopDate  = normaliseDate(order.orderStopDate);

    // ── 2. Parse lineDetails to extract Item + Color for the ATS fetch ───────
    // addSalesLine stores lines as: { fabricStyleCode, colorCode, ... }
    // The ATS criteria needs fabricStyleCode & fabricStyleColorCode (= colorCode).
    // We collect ALL unique style codes so the ATS fetch returns every item
    // that belongs to this order; pass the first one to the Item textbox since
    // the field is a single-value filter (user can clear it to see all).
    let parsedLines = [];
    try {
      const raw = order.lineDetails;
      parsedLines = raw
        ? (typeof raw === "string" ? JSON.parse(raw) : raw)
        : [];
      if (!Array.isArray(parsedLines)) parsedLines = [];
    } catch (_) { parsedLines = []; }

    const firstLine         = parsedLines[0] || {};
    const itemCode          = firstLine.fabricStyleCode      || "";
    // colorCode is the field name used when saving; fabricStyleColorCode is a
    // fallback for orders that stored the full field name instead.
    const colorCode         = firstLine.colorCode            ||
                              firstLine.fabricStyleColorCode || "";

    // ── 3. Build fresh criteria and sync to criteriaRef BEFORE loadFirst() ───
    // criteriaRef is read by loadPage(), so writing here ensures the fetch
    // uses the correct values even before React commits the state update.
    const freshCriteria = {
      ...criteriaRef.current,
      customerCode:          order.customerCode || criteriaRef.current.customerCode || "",
      fabricStyleCode:       itemCode,
      fabricStyleColorCode:  colorCode,
      companyCode:           process.env.REACT_APP_COMPANY,
    };
    criteriaRef.current = freshCriteria;   // synchronous — loadPage reads this
    setCriteria(freshCriteria);            // async  — updates the form display

    // ── 4. Populate requestCriteria (PO#, Order No., dates) ─────────────────
    setRequestCriteria((prev) => ({
      ...prev,
      customerPurchaseOrderNumber: order.customerPurchaseOrderNumber || "",
      customerOrderNumber:         order.customerOrder               || "",
      orderDate:                   normOrderDate,
      orderStartDate:              normOrderStartDate,
      orderStopDate:               normOrderStopDate,
    }));

    // ── 5. Restore Sales Order Node lines from lineDetails ───────────────────
    const restoredLines = parsedLines.map((ln) => {
      // Look up live ATS data for this style+color so On Hand Qty, Vendor On Order,
      // and Customer On Order are populated — these fields are NOT stored in
      // lineDetails (the server payload only persists order quantities), so without
      // this merge they would always display as 0.
      const liveAts = atsInfos.find(
        (a) =>
          a.fabricStyleCode      === (ln.fabricStyleCode || "") &&
          a.fabricStyleColorCode === (ln.fabricStyleColorCode || ln.colorCode || "")
      );

      return {
        fabricStyleCode:         ln.fabricStyleCode                         || "",
        fabricStyleColorCode:    ln.fabricStyleColorCode || ln.colorCode    || "",
        fabricStyleName:         ln.fabricStyleName      || liveAts?.fabricStyleName         || "",
        fabricStyleColorImagePath:    ln.fabricStyleColorImagePath || liveAts?.fabricStyleColorImagePath    || "",
        // Prefer live ATS values; fall back to whatever the server returned
        onHandQuantity:          liveAts?.onHandQuantity          ?? ln.onHandQuantity          ?? null,
        vendorOnOrderQuantity:   liveAts?.vendorOnOrderQuantity   ?? ln.vendorOnOrderQuantity   ?? null,
        customerOnOrderQuantity: liveAts?.customerOnOrderQuantity ?? ln.customerOnOrderQuantity ?? null,
        orderQuantity:           ln.orderQuantity           ?? null,
        colorCode:               ln.colorCode || ln.fabricStyleColorCode    || "",
        uomCode:                 ln.uomCode                                 || "YD",
        price:                   ln.price                                   ?? 0,
        etaDate:                 ln.etaDate                                 || "",
      };
    });

    // ── 6. Wire order refs so subsequent "+ Add Sales" appends correctly ──────
    const customerOrder = order.customerOrder || null;
    setSalesOrderLines(restoredLines);
    setSalesOrderNumber(customerOrder);
    currentCustomerOrderRef.current = customerOrder;
    // Build and store the header key so the FIRST "+ Add Sales" after opening
    // an existing order reuses the same customerOrder instead of creating a new one.
    const restoredHeaderKey = [
      order.customerCode                       || "",
      order.customerPurchaseOrderNumber        || "",
      normaliseDate(order.orderDate)           || "",
      normaliseDate(order.orderStartDate)      || "",
      normaliseDate(order.orderStopDate)       || "",
    ].join("|");
    lastHeaderKeyRef.current = restoredHeaderKey;

    // ── 7. Show Header Node so the freshly-fetched ATS cards are visible ─────
    // The user can then click "+ Add Sales" on any card; the Sales Order tab
    // badge will show the pre-loaded line count as a reminder.
    setActiveNode("header");

    // ── 8. Close list view ────────────────────────────────────────────────────
    setIsListView(false);

    // ── 9. Fire ATS fetch — criteriaRef is already up-to-date, so loadPage
    //       will send the correct fabricStyleCode / fabricStyleColorCode ───────
    loadFirst();
  };

  // ── table columns for desktop table view ──────────────────────────────────
  const openOnHandModal = (val, e, row) => openModal(1, row);

  const Columns = () => {
    const _columns = [];
    _columns.push(new ColumnDefinition().setDetails("Item",            "fabricStyleCode",        true).setStyleDetails("left",  "10", "", "wt-4", "wt-4"));
    _columns.push(new ColumnDefinition().setDetails("Name",            "fabricStyleName",         true).setStyleDetails("left",  "10", "", "wt-4", "wt-4"));
    _columns.push(new ColumnDefinition().setDetails("Color",           "fabricStyleColorCode",    true).setStyleDetails("left",  "10", "", "wt-3", "wt-3"));
    _columns.push(new ColumnDefinition().setDetails("OnHandQty",       "onHandQuantity",          true, true).setStyleDetails("right", "", "", "wt-3", "wt-3").setClickDetails(true, false, openOnHandModal));
    _columns.push(new ColumnDefinition().setDetails("Vendor On Order", "vendorOnOrderQuantity",   true).setStyleDetails("right", "", "", "wt-3", "wt-3"));
    _columns.push(new ColumnDefinition().setDetails("Cust On Order",   "customerOnOrderQuantity", true).setStyleDetails("right", "", "", "wt-3", "wt-3"));
    _columns.push(new ColumnDefinition().setDetails("Order Qty",       "orderQuantity",           true).setStyleDetails("right", "", "", "wt-3", "wt-3"));
    _columns.push(new ColumnDefinition().setDetails("Earliest ETA",    "etaDate",                 true).setStyleDetails("left",  "", "", "wt-3", "wt-3"));
    _columns.push(new ColumnDefinition().setDetails("Image",           "fabricStyleColorImagePath",    true).setStyleDetails("right", "", "", "wt-3", "wt-3").setImageDetails(true));
    return _columns;
  };

  // ── Individual fabric card (mobile) ─── Header Node ───────────────────────
  // Defined inside the main component so it can access token, criteria,
  // notify, errorCallBack, and addSalesLine via closure.
  const StyleCard = ({ ln }) => {
 
  
    
    const {
      fabricStyleCode,
      fabricStyleName,
      fabricStyleColorCode,
      fabricStyleColorImagePath,
      onHandQuantity,
      numberOfRolls,
      vendorOnOrderQuantity,
      customerOnOrderQuantity,
      orderQuantity,
      price,
      etaDate,
    } = ln;

    const isWhite   = (fabricStyleColorCode || "").toUpperCase().includes("WHITE");
    const isInOrder = salesOrderLines.some(
      (l) =>
        l.fabricStyleCode      === fabricStyleCode &&
        l.fabricStyleColorCode === fabricStyleColorCode
    );

    // True when this screen was opened from List View with a real order number.
    // In that case the Order Qty field must be read-only — no editing allowed.
    const isExistingOrder = !!requestCriteria.customerOrderNumber;

    // For an existing order, resolve the saved qty from the restored Sales Order
    // lines so the card always mirrors what the Sales Order Node shows.
    const savedOrderQty = isExistingOrder
      ? (salesOrderLines.find(
          (l) =>
            l.fabricStyleCode      === fabricStyleCode &&
            l.fabricStyleColorCode === fabricStyleColorCode
        )?.orderQuantity ?? orderQuantity)
      : orderQuantity;

    return (
      <div className="spo-style-card">
        {/* ── TOP: image + info ── */}
        <div className="spo-style-card__top">
          <div className="spo-style-card__img-wrap">
           <Image
  url={`${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_IMAGE_PATH}${
    ln.fabricStyleImagePath || ln.fabricStyleColorImagePath
  }`}
  altName={`${ln.fabricStyleCode} - image`}
/>
          </div>

          <div className="spo-style-card__info">
            <div className="spo-style-card__info-inner">
              {/* Top Row: style code + Add Sales button */}
              <div className="spo-card-info-top-row">
                <div className="spo-card-info-left">
                  <div className="spo-style-code">{fabricStyleCode}</div>
                  <div className="spo-style-name">{fabricStyleName}</div>
                </div>
                <button
                  className={`spo-add-sales-btn${isInOrder ? " spo-add-sales-btn--added" : ""}`}
                  onClick={() => addSalesLine(ln)}
                  disabled={isInOrder}
                >
                  {isInOrder ? "✓ Added" : "+ Add Sales"}
                </button>
              </div>

              {/* Color Badge */}
              <div className="spo-color-badge">
                <span
                  // className={`spo-color-badge__dot${isWhite ? " spo-color-badge__dot--white-border" : ""}`}
                  style={{ background:(fabricStyleColorCode) }}
                />
                <span className="spo-color-badge__text">{fabricStyleColorCode}</span>
              </div>
            </div>
          </div>
        </div>

        {/* ── DIVIDER ── */}
        <div className="spo-card-divider" />

        {/* ── DATA ROWS ── */}
        <div>
          <CardRow
            icon="📦"
            label="On Hand Qty"
            value={toCommaSeperatedAmount(onHandQuantity)}
            clickable
            onClick={() => openModal(1, ln)}
            // valueColor="#2563eb"
             valueColor="#16a34a"
          />
          <CardRow
            icon="🚚"
            label="Vendor On Order"
            value={toCommaSeperatedAmount(vendorOnOrderQuantity)}
            clickable
            onClick={() => openModal(2, ln)}
               valueColor="#2563eb"
          />
          <CardRow
            icon="🏪"
            label="Customer On Order"
            value={toCommaSeperatedAmount(customerOnOrderQuantity)}
            clickable
             onClick={() => openModal(3, ln)}
               valueColor="#2563eb"
          />
           <CardRow
            icon="💰"
            label="Price"
            value={toCommaSeperatedAmount(price)}
            rawValue={price || 0}
            editable={!disable}
            disable={disable}
            onValueChange={(newValue) => handleStylePriceChange(ln, newValue)}
            valueColor="#16a34a"
          />
          <CardRow
            icon="🛒"
            label="Order Qty"
            value={
              isExistingOrder
                ? (savedOrderQty != null
                    ? toCommaSeperatedAmount(savedOrderQty)
                    : <span className="spo-order-qty-placeholder">—</span>)
                : (orderQuantity != null
                    ? toCommaSeperatedAmount(orderQuantity)
                    : <span className="spo-order-qty-placeholder">Tap to add ›</span>)
            }
            clickable={!isExistingOrder}
            onClick={!isExistingOrder ? () => openModal(4, ln) : undefined}
            valueColor={isExistingOrder ? "#6b7280" : "#ea580c"}
            last
          />
        </div>
      </div>
    );
  };

  // ── Unified Responsive Card Grid (replaces separate Mobile/Desktop views) ─
  // On mobile (<= 640 px) → 1 column full-width cards.
  // On tablet (641–1024 px) → 2 columns.
  // On desktop (> 1024 px) → 3–4 columns auto-fit.
  // The grid is CSS-driven via a <style> block — no JS breakpoint logic needed.
 

  const ResponsiveCardGrid = ({ atsInfos }) => (
    
    
    <div className="spo-responsive-grid-wrap">
      <div className="spo-responsive-grid-header">
        Total Styles: <span className="spo-count-highlight">{totalCount}</span>
        {" | "}
        Showing: <span className="spo-count-highlight">{atsInfos.length}</span>
        {" | "}
        Page <span className="spo-count-highlight">{page}</span> of{" "}
        <span className="spo-count-highlight">{maxPage}</span>
      </div>
      <div className="spo-responsive-grid">
        {atsInfos.map((ln, idx) => (
          <StyleCard key={idx} ln={ln} />
        ))}
      </div>
    </div>
  );

  // Keep legacy aliases so any code still referencing them doesn't break
  const MobileCardView  = ResponsiveCardGrid;
  const DesktopCardView = ResponsiveCardGrid;

  // ── Portal Sales Order List View — responsive card layout ──────────────────
  const PortalSalesOrderListView = ({ orders }) => {
    if (isEmptyArray(orders)) {
      return (
        <div className="spo-list-empty">
          <div className="spo-list-empty__icon">📋</div>
          <div className="spo-list-empty__text">No sales orders found</div>
          <div className="spo-list-empty__sub">Try clicking the SwapIcon again to refresh</div>
        </div>
      );
    }
    return (
      <div className="spo-list-view-wrap">
        <div className="spo-list-view-header">
          Total Orders: <span className="spo-count-highlight">{orders.length}</span>
        </div>
        {/* ── Responsive card grid ── */}
        <div className="spo-lv-card-grid">
          {orders.map((order, idx) => {
            const lvOrderKey = `lv-order-${idx}`;
            const isConfirmingThis = confirmingOrderKey === lvOrderKey;

            // Parse line count for display badge
            let lineCount = 0;
            try {
              const raw = order.lineDetails
                ? (typeof order.lineDetails === "string" ? JSON.parse(order.lineDetails) : order.lineDetails)
                : [];
              lineCount = Array.isArray(raw) ? raw.length : 0;
            } catch (_) {}

            return (
              <div key={idx} className="spo-lv-card">
                {/* ── Card Header ── */}
                <div className="spo-lv-card__header">
                  <div className="spo-lv-card__order-num">
                    <a
                      href="#"
                      className="spo-lv-order-link"
                      onClick={(e) => { e.preventDefault(); handleOrderNumberClick(order); }}
                    >
                      <span className="spo-lv-card__label"> Customer Order#</span>
                      <span >
                      {order.customerOrder || "—"}
                      </span>
                    </a>
                  </div>
                  {lineCount > 0 && (
                    <span className="spo-lv-card__line-badge">{lineCount} line{lineCount !== 1 ? "s" : ""}</span>
                  )}
                </div>

                {/* ── Card Body rows ── */}
                <div className="spo-lv-card__body">
                  <div className="spo-lv-card__row">
                    <span className="spo-lv-card__label">👤 Customer</span>
                    <span className="spo-lv-card__value">{order.customerCode || "—"}</span>
                  </div>
                  <div className="spo-lv-card__row">
                    <span className="spo-lv-card__label">📄 Customer PO#</span>
                    <span className="spo-lv-card__value">{order.customerPurchaseOrderNumber || "—"}</span>
                  </div>
                  <div className="spo-lv-card__row">
                    <span className="spo-lv-card__label">📅 Order Date</span>
                    <span className="spo-lv-card__value">{formatDateMMDDYYYY(order.orderDate)}</span>
                  </div>
                  <div className="spo-lv-card__row">
                    <span className="spo-lv-card__label">🗓 Start Date</span>
                    <span className="spo-lv-card__value">{formatDateMMDDYYYY(order.orderStartDate)}</span>
                  </div>
                  <div className="spo-lv-card__row">
                    <span className="spo-lv-card__label">🗓 Stop Date</span>
                    <span className="spo-lv-card__value">{formatDateMMDDYYYY(order.orderStopDate)}</span>
                  </div>
                </div>

                {/* ── ONE "Sales Order" (Confirm) button per order ── */}
                <div className="spo-lv-card__footer">
                  <button
                    className="spo-lv-sales-order-btn"
                    disabled={isConfirmingThis}
                    onClick={() => {
                      setConfirmingOrderKey(lvOrderKey);
                      confirmOrder(order);
                    }}
                  >
                    {isConfirmingThis ? "Confirming…" : "Confirm Order"}
                  </button>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    );
  };

  // ── render ─────────────────────────────────────────────────────────────────
  return (
    <>
      <style>{SPO_INLINE_STYLES}</style>
      <style>{LOOKUP_MODAL_STYLES}</style>

      {/* ── Inline Lookup Modals ── */}
      <CustomerLookupModal
        isOpen={isCustomerLookupOpen}
        onClose={() => setIsCustomerLookupOpen(false)}
        onSelect={onCustomerLookupSelect}
        token={token}
        serviceCall={service}
      />
      <FabricStyleLookupModal
        isOpen={isFabricLookupOpen}
        onClose={() => setIsFabricLookupOpen(false)}
        onSelect={onFabricLookupSelect}
        token={token}
        serviceCall={service}
      />
      {isLoading ? <Loader /> : null}

      {/* ── Vendor On Order modal ── */}
      <Modal isOpen={isOnVenOdrModelOpen} onClose={closeModal} title="Vendor On Order Details">
        <VendorOnOrderDetails onOrderLines={onOrderLines} />
      </Modal>

      {/* ── On Hand modal ── */}
      <Modal isOpen={isOnHandModelOpen} onClose={closeModal} title="On Hand Details">
        <OnHandQtyDetails invLines={invLines} />
      </Modal>

      {/* ── Customer On Order modal ── */}
      <Modal isOpen={isCustOnOrderModelOpen} onClose={closeModal} title="Customer On Order Details">
        <CustomerOnOrderDetails customerOnOrderLines={customerOnOrderLines} />
      </Modal>

      {/* ── Order Qty manual input popup ── */}
      <OrderQtyPopup
        isOpen={isOrderQtyPopupOpen}
        item={selectedItem}
        onClose={closeModal}
        onSave={handleSaveOrderQty}
      />

      {/* Toolbar */}
      <ToolBar
        title={title}
        // PDFHandler={PDFHandler}
        // ExcelHandler={ExcelHandler}
        ResetHandler={ResetHandler}
        ExecuteHandler={loadFirst}
        getModuleListView={getModuleListView}
        isListView={true}
        isShowPdf={isShowPdf}
        isShowExcel={isShowExcel}
      />

      {/* ════════════════════════════════════════════════════════════════════ */}
      {/* LIST VIEW SCREEN — shown ONLY when getModuleListView is active       */}
      {/* Completely separate from the Header/Sales Order node flow below      */}
      {/* ════════════════════════════════════════════════════════════════════ */}
      {isListView && (
        <div className="spo-listview-screen">
          {/* ── Screen header bar ── */}
          <div className="spo-listview-screen__header">
            <div className="spo-listview-screen__header-left">
              <span className="spo-listview-screen__icon">📋</span>
              <div>
                <div className="spo-listview-screen__title">Portal Sales Orders</div>
                <div className="spo-listview-screen__subtitle">
                  Existing saved orders — fetched via List View
                </div>
              </div>
            </div>
            <button
              className="spo-listview-screen__close-btn"
              onClick={getModuleListView}
              title="Close List View"
            >
              ✕ Close List View
            </button>
          </div>

          {/* ── The orders table ── */}
          <div className="spo-listview-screen__body">
            <PortalSalesOrderListView orders={portalSalesOrders} />
          </div>
        </div>
      )}

      {/* ════════════════════════════════════════════════════════════════════ */}
      {/* NORMAL FLOW — Search form + Node tabs (hidden while list view open)  */}
      {/* ════════════════════════════════════════════════════════════════════ */}
      {!isListView && (
        <>
          {/* Search form */}
          <div className="card-body">
            <div className="row">

              <div className="form-group col-5">
                <InputTextBox
                  value={
                    requestCriteria.customerOrderNumber
                      ? requestCriteria.customerOrderNumber
                      : "New"
                  }
                  required={false}
                  name="customerOrderNumber"
                  placeholder="Customer Order No."
                  label="Customer Order No."
                  enterKeyHandler={() => enterKeyHandler("customerCode")}
                  onChange={undefined}
                  disable={true}
                  readOnly={true}
                />
              </div>
              <div className="form-group col-5">
                <InputTextbox
                  onChange={onCustomerCodeChange}
                  ref={customerCodeRef}
                  name="customerCode"
                  placeholder="Customer"
                  value={criteria.customerCode}
                  enterKeyEventHandler={customerCodeEnterKeyEventHandler}
                  autoCompleteListData={customerPageListForAutoCompleteList}
                  enableAutoCompleteTextBox={true}
                  displayAutoCompleteList={displayAutoCompleteCustomerList}
                  showAutoCompleteList={showAutoCompleteCustomerList}
                  isMandatory={true}
                  isNotFound={isCustomerNotFound}
                  label="Customer"
                  inputRef={inputRef}
                  lookupList={customerPageListForAutoCompleteList}
                  showLookupDropdown={showAutoCompleteCustomerList && customerPageListForAutoCompleteList.length > 0}
                  onLookupSelect={(item) => onCustomerLookupSelect(item)}
                  onHideLookupDropdown={() => setShowAutoCompleteCustomerList(false)}
                    disable={disable}
                />
              </div>
                            <div className="form-group col-5">
                <InputTextBox
                  value={customerName.description}
                  required={true}
                  name="customerPurchaseOrderNumber"
                    enterKeyHandler={(e) => focusNext(e.target)}
                  label="CustomerName"
                  // enterKeyHandler={enterKeyHandler}
                  onChange={onChanges}
                  disable={true}
                />
              </div>
             
              <div className="form-group col-5">
                <InputTextBox
                  ref={poNumberRef}
                  value={requestCriteria.customerPurchaseOrderNumber}
                  required={true}
                  name="customerPurchaseOrderNumber"
                  placeholder="Enter Customer PO"
                  label="CustomerPONumber"
                 // enterKeyHandler={() => enterKeyHandler("customerPurchaseOrderNumber")}
                  onChange={onChanges}
                  disable={disable}
                   enterKeyHandler={(e) => focusNext(e.target)}
                />
              </div>
              
              <div className="form-group col-5">
                <DatePicker
                  ref={orderDateRef}
                  value={requestCriteria.orderDate}
                  required={true}
                  type="date"
                  name="orderDate"
                  label="OrderDate"
                  enterKeyHandler={() => enterKeyHandler("orderDate")}
                  onChange={onChanges}
                  disable={disable}
                />
              </div>
              <div className="form-group col-5">
                <DatePicker
                  ref={orderStartDateRef}
                  value={requestCriteria.orderStartDate}
                  required={true}
                  name="orderStartDate"
                  type="date"
                  label="OrderStartDate"
                  enterKeyHandler={() => enterKeyHandler("orderStartDate")}
                  onChange={onChanges}
                  disable={disable}
                />
              </div>
              <div className="form-group col-5">
                <DatePicker
                  ref={orderStopDateRef}
                  value={requestCriteria.orderStopDate}
                  required={true}
                  name="orderStopDate"
                  type="date"
                  label="OrderStopDate"
                  enterKeyHandler={() => enterKeyHandler("orderStopDate")}
                  onChange={onChanges}
                  disable={disable}
                />
              </div>
              <div className="form-group col-fit">
                
                <CustomButton
                  buttonHandler={buttonSaveHandler}
                  disable={disable}
                  buttonRef={buttonRef}
                  label="Save"
                  
                />
              </div>
            </div>
          </div>

          {/* ── Fabric / Color / Fetch — always visible ── */}
          <div className="card-body">
            <div className="row">
              <div className="form-group col-5">
                <InputTextbox
                  onKeyDown={onfabricKeyDown}
                  onValueChangeOnBlur={onfabricBlur}
                  valueChangeOnBlur={true}
                  ref={fabricStyleCodeRef}
                  name="fabricStyleCode"
                  onChange={onFabricCodeChange}
                  value={criteria.fabricStyleCode}
                  enterKeyEventHandler={fabricenterKeyEventHandler}
                  autoCompleteListData={fabricPageListForAutoCompleteList}
                  enableAutoCompleteTextBox={true}
                  displayAutoCompleteList={displayAutoCompleteFabricCodeList}
                  showAutoCompleteList={showAutoCompleteFabricCodeList}
                  isMandatory={true}
                  label="Item / Fabric"
                  placeholder="Item/Fabric"
                  lookupList={fabricPageListForAutoCompleteList}
                  showLookupDropdown={showAutoCompleteFabricCodeList && fabricPageListForAutoCompleteList.length > 0}
                  onLookupSelect={(item) => onFabricLookupSelect(item)}
                  onHideLookupDropdown={() => setShowAutoCompleteFabricCodeList(false)}
                    disable={disable}
                />
              </div>
              <div className="form-group col-5">
                <InputTextBox
                  ref={colorCodeRef}
                  value={criteria.fabricStyleColorCode}
                  required={true}
                  name="fabricStyleColorCode"
                  placeholder="Enter color code"
                  label="Color"
                  enterKeyHandler={() => enterKeyHandler("fabricStyleColorCode")}
                  onChange={(e) => {
                    onChange(e);
                    const val = e.target.value.toUpperCase();
                    if (!val) {
                      setShowAutoCompleteColorList(false);
                    } else if (colorList.length > 0) {
                      setShowAutoCompleteColorList(true);
                    }
                  }}
                  disable={disable}
                  lookupList={colorList.filter((c) =>
                    !criteria.fabricStyleColorCode ||
                    c.code.toUpperCase().includes((criteria.fabricStyleColorCode || "").toUpperCase())
                  )}
                  showLookupDropdown={showAutoCompleteColorList && colorList.length > 0}
                  onLookupSelect={(item) => {
                   
                    
                    setCriteria((prev) => {
                      const next = { ...prev, fabricStyleColorCode: item.code };
                      criteriaRef.current = next;
                      return next;
                    });
                    setShowAutoCompleteColorList(false);
                  }}
                  onHideLookupDropdown={() => setShowAutoCompleteColorList(false)}
                />
              </div>
              <div className="form-group col-fit">
                <CustomButton
                  buttonHandler={buttonHandler}
                  disable={disable}
                  buttonRef={fetchButtonRef}
                  label="Fetch"
                />
              </div>
            </div>
          </div>

          {/* ── Node Tab Switcher: Header Node + Sales Order Node — always visible ── */}
          <div className="card-body">
            {/* ── Tab Toggle Bar ── */}
            <div className="spo-node-tab-bar">
              {/* <button
                className={`spo-node-tab${activeNode === "header" ? " spo-node-tab--active spo-node-tab--blue" : ""}`}
                onClick={() => setActiveNode("header")}
              >
                <span className="spo-node-tab__dot spo-node-tab__dot--blue" />
                📋 fabric detail Node
              </button> */}
               {/* {requestCriteria.customerOrderNumber === "New" && ( */}
      <button
        className={`spo-node-tab${
          activeNode === "header"
            ? " spo-node-tab--active spo-node-tab--blue"
            : ""
        }`}
        onClick={() => setActiveNode("header")}
      >
        <span className="spo-node-tab__dot spo-node-tab__dot--blue" />
        📋 Fabric Details
      </button>
   {/* )} */}
              <button
                className={`spo-node-tab${activeNode === "salesOrder" ? " spo-node-tab--active spo-node-tab--green" : ""}`}
                onClick={() => setActiveNode("salesOrder")}
              >
                <span className="spo-node-tab__dot spo-node-tab__dot--green" />
                🛒Order Details
                {salesOrderLines.length > 0 && (
                  <span className="spo-node-tab__badge">{salesOrderLines.length}</span>
                )}
              </button>
            </div>

            {/* ── NODE 1: Header Node ── */}
            {activeNode === "header"  && (
              <div className="spo-node-panel">
                {!isEmptyArray(atsInfos) ? (
                  <>
                    <div className="card-title"><h1>SALE Details</h1></div>
                    {/* ── Pagination + view toggle — lives inside Header Node ── */}
                    <div className="spo-header-node-controls">
                      <PageBar
                        loadFirst={loadFirst}
                        loadNext={loadNext}
                        loadPrevious={loadPrevious}
                        loadLast={loadLast}
                        page={page}
                      />
                      {/* <ViewToggle
                        listViewHandler={listViewHandler}
                        gridViewHandler={gridViewHandler}
                      /> */}
                    </div>
                    <div className="list-wrap spo-list-wrap">
                      <ResponsiveCardGrid atsInfos={atsInfos} />
                    </div>
                  </>
                ) : (
                  <div className="spo-node-empty-hint">
                    Enter a Fabric/Item above and click <strong>Fetch</strong> to load styles.
                  </div>
                )}
              </div>
            )}

            {/* ── NODE 2: Sales Order Node ── */}
            {activeNode === "salesOrder" && (
              <div className="spo-node-panel">
                <SalesOrderNode
                  salesOrderLines={salesOrderLines}
                  salesOrderNumber={salesOrderNumber}
                  onConfirmOrder={saveAndConfirmOrder}
                  confirmingOrderKey={confirmingOrderKey}
                  disable={disable}
                  onPriceChange={updateLinePrice}
                />
              </div>
            )}
          </div>
        </>
      )}

      <InValidAccess isShow={isAccessible} clickHandler={onClose} />
    </>
  );
}